<template>
  <div class="portalCms-addColumn">
    <el-header class="decision-management-header" height="32px">
      <div class="decision-management-header-wrap">
        <span>决策中心>菜单管理</span>
      </div>
    </el-header>
    <div class="portalCms-addColumn-header">
      <span>{{ title }}</span>
      <div style="flex: 1"></div>
      <!-- <el-button @click="$router.push({ name: 'Column' })">返回</el-button> -->
    </div>
    <el-form
      :model="cmsColumn"
      :rules="cmsColumnRules"
      ref="cmsColumn"
      label-width="110px"
      class="portalCms-addColumn-form"
      :elValidator="type"
    >
      <el-form-item label="菜单图标" prop="menuIcon">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :show-file-list="false"
          accept=".svg, .png"
          :before-upload="beforeUpload"
          :http-request="(param) => onRequest(param, cmsColumn)"
        >
          <template v-if="cmsColumn.menuIcon">
            <img :src="cmsColumn.menuIcon" class="avatar" />
          </template>
          <template v-else>
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item label="上级菜单" prop="pid">
        <!-- <el-select v-model="cmsColumn.pId" placeholder="请选择上级菜单">
          <el-option
            v-for="list in columnList"
            :key="list.id"
            :label="list.columnName"
            :value="list.id"
          ></el-option>
        </el-select> -->
        <el-cascader
          v-model="cmsColumn.pid"
          :options="MenuList"
          @change="handleChange"
          :show-all-levels="false"
          :props="{ checkStrictly: true }"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="菜单名称" prop="menuName">
        <el-input
          v-model="cmsColumn.menuName"
          placeholder="请输入菜单名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单编号" prop="menuCode">
        <el-input
          v-model="cmsColumn.menuCode"
          placeholder="请输入菜单编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="排列序号" prop="sortNum">
        <el-input
          v-model="cmsColumn.sortNum"
          placeholder="请输入排列序号"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单链接" prop="contentUrl">
        <el-input
          v-model="cmsColumn.contentUrl"
          placeholder="请输入栏目链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单描述" prop="menuDescription">
        <el-input
          type="textarea"
          v-model="cmsColumn.menuDescription"
        ></el-input>
      </el-form-item>
      <el-form-item label="可浏览部门">
        <el-select
          v-model="cmsColumn.deptList"
          placeholder="请选择可浏览部门"
          @visible-change="DrawerTreeVisible = true"
          multiple
          collapse-tags
          popper-class="portalCms-addColumn-userOrgSelect"
        >
          <el-option
            v-for="item in cmsColumn.deptList"
            :key="item.id"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可浏览用户组" prop="groupList">
        <el-select
          v-model="cmsColumn.groupList"
          placeholder="请选择可浏览用户组"
          multiple
        >
          <el-option
            v-for="list in GroupTree"
            :key="list.id"
            :label="list.name"
            :value="list.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可浏览角色" prop="roleList">
        <el-select
          v-model="cmsColumn.roleList"
          placeholder="请选择可浏览角色"
          multiple
        >
          <el-option
            v-for="list in RoleTree"
            :key="list.id"
            :label="list.name"
            :value="list.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('cmsColumn')"
          >保存</el-button
        >
        <el-button @click="resetForm('cmsColumn')">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 部门选择 -->
    <el-drawer :visible.sync="DrawerTreeVisible" direction="rtl" size="600px">
      <DrawerTree
        :baseUserUrl="baseUserUrl"
        @choose="chooseOrg"
        :request="request"
        :data.sync="cmsColumn.deptList"
        :id="deptList"
        department
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  getColumnList,
  getColumnTemplateList,
  getOrganizationTree,
  getGroupTree,
  getRoleTree,
  postSaveColumn,
  getWorkConList,
  getOneColumn,
} from "@/api/cms-api";
import { saveOrUpdateMenu, getMenuById, getMenuList } from "@/api/shangcai.js";
import { mapGetters } from "vuex";

export default {
  name: "addColumn",
  computed: {
    ...mapGetters(["request"]),
  },
  data() {
    return {
      // 新增栏目
      title: "新增菜单",
      type: true,
      // 栏目id
      columnId: "",
      // 表单列表
      cmsColumn: {
        menuIcon: "",
        // 栏目名称
        menuName: "",
        // 栏目代码
        menuCode: "",
        // 选择部门是否显示
        roleList: [],
        // 选择用户组列表
        groupList: [],
        // 菜单描述
        menuDescription: "",
        sortNum: "",
        deptList: [],
        contentUrl: "",
        pid: "",
      },
      // 表单校验
      cmsColumnRules: {
        // menuIcon: [{ required: true, message: "请上传图标", trigger: "blur" }],
        menuName: [
          { required: true, message: "请输入菜单名称", trigger: "blur" },
        ],
        menuCode: [
          { required: true, message: "请输入菜单代码", trigger: "blur" },
        ],
        deptList: [
          { required: true, message: "请选择可浏览部门", trigger: "change" },
        ],
        // roleList: [
        //   { required: true, message: "请选择可浏览角色", trigger: "change" },
        // ],
        // groupList: [
        //   { required: true, message: "请选择可浏览用户组", trigger: "change" },
        // ],
        flowId: [
          { required: true, message: "请选择审核流程", trigger: "change" },
        ],
        contentUrl: [
          { required: true, message: "请输入菜单地址", trigger: "blur" },
        ],
        pid: [{ required: true, message: "请选择上级菜单", trigger: "change" }],
      },
      // 栏目列表
      columnList: [],
      // 栏目模板列表
      columnTemplateList: [],
      // 部门树
      OrganizationTree: [],
      // 选择部门列表
      deptList: [],
      // 用户组列表
      GroupTree: [],
      // 角色列表
      RoleTree: [],
      // 选择角色列表
      DrawerTreeVisible: false,
      // 上传文件api
      uploadUrl: "",
      // 审核流程
      workConList: [],
      baseUserUrl: "",
      // MenuList: [
      //   {
      //     value: "zhinan",
      //     id: 1,
      //     pid: 1,
      //     label: "指南",
      //     children: [
      //       {
      //         value: "shejiyuanze",
      //         label: "设计原则",
      //         children: [
      //           {
      //             value: "yizhi",
      //             label: "一致",
      //           },
      //           {
      //             value: "fankui",
      //             label: "反馈",
      //           },
      //           {
      //             value: "xiaolv",
      //             label: "效率",
      //           },
      //           {
      //             value: "kekong",
      //             label: "可控",
      //           },
      //         ],
      //       },
      //       {
      //         value: "daohang",
      //         label: "导航",
      //         children: [
      //           {
      //             value: "cexiangdaohang",
      //             label: "侧向导航",
      //           },
      //           {
      //             value: "dingbudaohang",
      //             label: "顶部导航",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     value: "zujian",
      //     label: "组件",
      //     children: [
      //       {
      //         value: "basic",
      //         label: "Basic",
      //         children: [
      //           {
      //             value: "layout",
      //             label: "Layout 布局",
      //           },
      //           {
      //             value: "color",
      //             label: "Color 色彩",
      //           },
      //           {
      //             value: "typography",
      //             label: "Typography 字体",
      //           },
      //           {
      //             value: "icon",
      //             label: "Icon 图标",
      //           },
      //           {
      //             value: "button",
      //             label: "Button 按钮",
      //           },
      //         ],
      //       },
      //       {
      //         value: "form",
      //         label: "Form",
      //         children: [
      //           {
      //             value: "radio",
      //             label: "Radio 单选框",
      //           },
      //           {
      //             value: "checkbox",
      //             label: "Checkbox 多选框",
      //           },
      //           {
      //             value: "input",
      //             label: "Input 输入框",
      //           },
      //           {
      //             value: "input-number",
      //             label: "InputNumber 计数器",
      //           },
      //           {
      //             value: "select",
      //             label: "Select 选择器",
      //           },
      //           {
      //             value: "cascader",
      //             label: "Cascader 级联选择器",
      //           },
      //           {
      //             value: "switch",
      //             label: "Switch 开关",
      //           },
      //           {
      //             value: "slider",
      //             label: "Slider 滑块",
      //           },
      //           {
      //             value: "time-picker",
      //             label: "TimePicker 时间选择器",
      //           },
      //           {
      //             value: "date-picker",
      //             label: "DatePicker 日期选择器",
      //           },
      //           {
      //             value: "datetime-picker",
      //             label: "DateTimePicker 日期时间选择器",
      //           },
      //           {
      //             value: "upload",
      //             label: "Upload 上传",
      //           },
      //           {
      //             value: "rate",
      //             label: "Rate 评分",
      //           },
      //           {
      //             value: "form",
      //             label: "Form 表单",
      //           },
      //         ],
      //       },
      //       {
      //         value: "data",
      //         label: "Data",
      //         children: [
      //           {
      //             value: "table",
      //             label: "Table 表格",
      //           },
      //           {
      //             value: "tag",
      //             label: "Tag 标签",
      //           },
      //           {
      //             value: "progress",
      //             label: "Progress 进度条",
      //           },
      //           {
      //             value: "tree",
      //             label: "Tree 树形控件",
      //           },
      //           {
      //             value: "pagination",
      //             label: "Pagination 分页",
      //           },
      //           {
      //             value: "badge",
      //             label: "Badge 标记",
      //           },
      //         ],
      //       },
      //       {
      //         value: "notice",
      //         label: "Notice",
      //         children: [
      //           {
      //             value: "alert",
      //             label: "Alert 警告",
      //           },
      //           {
      //             value: "loading",
      //             label: "Loading 加载",
      //           },
      //           {
      //             value: "message",
      //             label: "Message 消息提示",
      //           },
      //           {
      //             value: "message-box",
      //             label: "MessageBox 弹框",
      //           },
      //           {
      //             value: "notification",
      //             label: "Notification 通知",
      //           },
      //         ],
      //       },
      //       {
      //         value: "navigation",
      //         label: "Navigation",
      //         children: [
      //           {
      //             value: "menu",
      //             label: "NavMenu 导航菜单",
      //           },
      //           {
      //             value: "tabs",
      //             label: "Tabs 标签页",
      //           },
      //           {
      //             value: "breadcrumb",
      //             label: "Breadcrumb 面包屑",
      //           },
      //           {
      //             value: "dropdown",
      //             label: "Dropdown 下拉菜单",
      //           },
      //           {
      //             value: "steps",
      //             label: "Steps 步骤条",
      //           },
      //         ],
      //       },
      //       {
      //         value: "others",
      //         label: "Others",
      //         children: [
      //           {
      //             value: "dialog",
      //             label: "Dialog 对话框",
      //           },
      //           {
      //             value: "tooltip",
      //             label: "Tooltip 文字提示",
      //           },
      //           {
      //             value: "popover",
      //             label: "Popover 弹出框",
      //           },
      //           {
      //             value: "card",
      //             label: "Card 卡片",
      //           },
      //           {
      //             value: "carousel",
      //             label: "Carousel 走马灯",
      //           },
      //           {
      //             value: "collapse",
      //             label: "Collapse 折叠面板",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     value: "ziyuan",
      //     label: "资源",
      //     children: [
      //       {
      //         value: "axure",
      //         label: "Axure Components",
      //       },
      //       {
      //         value: "sketch",
      //         label: "Sketch Templates",
      //       },
      //       {
      //         value: "jiaohu",
      //         label: "组件交互文档",
      //       },
      //     ],
      //   },
      // ],
      // menuList: {},
      menuList: {
        tree: {
          id: "0",
          companyId: null,
          deleted: false,
          addAccount: null,
          addTime: null,
          editAccount: null,
          editTime: null,
          deleteAccount: null,
          deleteTime: null,
          code: "root",
          name: "根",
          memo: null,
          status: null,
          applicationId: null,
          parentId: null,
          type: null,
          icon: null,
          origin: null,
          url: null,
          target: null,
          order: null,
          level: null,
          lft: null,
          rgt: null,
          children: [
            {
              id: "00000",
              companyId: null,
              deleted: false,
              addAccount: null,
              addTime: null,
              editAccount: null,
              editTime: null,
              deleteAccount: null,
              deleteTime: null,
              code: "admin-management",
              name: "管理中心",
              memo: null,
              status: "1",
              applicationId: "00000",
              parentId: "0",
              type: "2",
              icon: "el-icon-s-grid",
              origin: "http://admin-management.paas.newcapec.cn",
              url: "",
              target: null,
              order: 0,
              level: 1,
              lft: 1,
              rgt: 20,
              children: [
                {
                  id: "10000",
                  companyId: null,
                  deleted: false,
                  addAccount: null,
                  addTime: null,
                  editAccount: "smartadmin",
                  editTime: "2021-03-01T15:50:15.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "admin.mgt",
                  name: "基础管理",
                  memo: null,
                  status: "1",
                  applicationId: "00000",
                  parentId: "00000",
                  type: "2",
                  icon: "",
                  origin: "http://admin-management.paas.newcapec.cn",
                  url: "/",
                  target: null,
                  order: 10000,
                  level: 1,
                  lft: 2,
                  rgt: 19,
                  children: [
                    {
                      id: "10100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.account",
                      name: "帐号管理",
                      memo: null,
                      status: "0",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-account",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/account",
                      target: null,
                      order: 10100,
                      level: 2,
                      lft: 3,
                      rgt: 4,
                      children: [],
                    },
                    {
                      id: "10200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: "smartadmin",
                      editTime: "2021-03-01T16:01:58.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.role",
                      name: "角色管理",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-identity",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/role",
                      target: null,
                      order: 10200,
                      level: 2,
                      lft: 5,
                      rgt: 6,
                      children: [],
                    },
                    {
                      id: "10250",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.rolePermission",
                      name: "角色权限",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-identity",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/rolePermission",
                      target: null,
                      order: 10250,
                      level: 2,
                      lft: 7,
                      rgt: 8,
                      children: [],
                    },
                    {
                      id: "10300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.application",
                      name: "应用管理",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-pm-warning-management",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/application",
                      target: null,
                      order: 10300,
                      level: 2,
                      lft: 9,
                      rgt: 10,
                      children: [],
                    },
                    {
                      id: "10400",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.menu",
                      name: "菜单管理",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-more",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/menu",
                      target: null,
                      order: 10400,
                      level: 2,
                      lft: 11,
                      rgt: 12,
                      children: [],
                    },
                    {
                      id: "10500",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.operation",
                      name: "操作管理",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-file",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/operation",
                      target: null,
                      order: 10500,
                      level: 2,
                      lft: 13,
                      rgt: 14,
                      children: [],
                    },
                    {
                      id: "10600",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.resource",
                      name: "资源管理",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-mechanism",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/resource",
                      target: null,
                      order: 10600,
                      level: 2,
                      lft: 15,
                      rgt: 16,
                      children: [],
                    },
                    {
                      id: "10700",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "admin.mgt.route",
                      name: "路由管理",
                      memo: null,
                      status: "1",
                      applicationId: "00000",
                      parentId: "10000",
                      type: "2",
                      icon: "su-icon-pm-ISTO",
                      origin: "http://admin-management.paas.newcapec.cn",
                      url: "/admin-mgt/route",
                      target: null,
                      order: 10700,
                      level: 2,
                      lft: 17,
                      rgt: 18,
                      children: [],
                    },
                  ],
                },
              ],
            },
            {
              id: "f2c44470766711ebc1efeeb47ed3ca72",
              companyId: "1",
              deleted: false,
              addAccount: "smartadmin",
              addTime: "2021-02-24T14:17:19.000+0800",
              editAccount: "smartadmin",
              editTime: "2021-02-24T14:34:52.000+0800",
              deleteAccount: null,
              deleteTime: null,
              code: "v8",
              name: "一卡通",
              memo: null,
              status: "1",
              applicationId: "09f63db0646111eba70f7fae370101e5",
              parentId: "0",
              type: "2",
              icon: "su-icon-hutiguanli",
              origin: null,
              url: null,
              target: "iframe",
              order: 0,
              level: 1,
              lft: 3227,
              rgt: 4646,
              children: [
                {
                  id: "f2c6dc80766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:19.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-10",
                  name: "库存管理",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 1,
                  level: 2,
                  lft: 3146,
                  rgt: 3221,
                  children: [
                    {
                      id: "f2cb7060766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:19.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-1262",
                      name: "出入库管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2c6dc80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 3203,
                      rgt: 3220,
                      children: [
                        {
                          id: "f2cd9340766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1263",
                          name: "入库登记",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2cb7060766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/kcinreg?menuid=1263",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3218,
                          rgt: 3219,
                          children: [],
                        },
                        {
                          id: "f2d115b0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1264",
                          name: "出库登记",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2cb7060766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/kcoutreg?menuid=1264",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3216,
                          rgt: 3217,
                          children: [],
                        },
                        {
                          id: "f2d2c360766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1267",
                          name: "库存调拨",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2cb7060766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/kcdb?menuid=1267",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3212,
                          rgt: 3215,
                          children: [],
                        },
                        {
                          id: "f2d4bf30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1266",
                          name: "库存调节",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2cb7060766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/kctj?menuid=1266",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 3208,
                          rgt: 3211,
                          children: [],
                        },
                        {
                          id: "f2d70920766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1265",
                          name: "坏卡登记",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2cb7060766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/badcard/badcardmanage?menuid=1265",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 3204,
                          rgt: 3207,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f2d9a130766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:19.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-1251",
                      name: "信息管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2c6dc80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 3171,
                      rgt: 3202,
                      children: [
                        {
                          id: "f2dcae70766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1252",
                          name: "卡片身份定义",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2d9a130766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/cardtypedef?menuid=1252",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3190,
                          rgt: 3201,
                          children: [],
                        },
                        {
                          id: "f2ded150766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1259",
                          name: "校区定义",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2d9a130766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/schooldef/schooldistrictdef?menuid=1259",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3174,
                          rgt: 3189,
                          children: [],
                        },
                        {
                          id: "f2e030e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1253",
                          name: "库存类型管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2d9a130766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/KcStockTypeDef/queryKcStockTypeDefInfo?menuid=1253",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3172,
                          rgt: 3173,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f2e1de90766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:19.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2050",
                      name: "查询统计",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2c6dc80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 3,
                      level: 3,
                      lft: 3147,
                      rgt: 3170,
                      children: [
                        {
                          id: "f2e3da60766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2059",
                          name: "按卡类型统计用卡量",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2e1de90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/schoolcardcountbycardtype/kcschoolcardcountbycardtype?menuid=2059",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3168,
                          rgt: 3169,
                          children: [],
                        },
                        {
                          id: "f2e58810766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1271",
                          name: "出入库登记查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2e1de90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/crkcx?menuid=1271",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3162,
                          rgt: 3167,
                          children: [],
                        },
                        {
                          id: "f2e735c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2062",
                          name: "按身份统计用卡量",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2e1de90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/schoolcardcountbypcode/kcschoolcardcountbypcode?menuid=2062",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3160,
                          rgt: 3161,
                          children: [],
                        },
                        {
                          id: "f2e958a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1275",
                          name: "其他分类统计用卡量",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2e1de90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/qttj?menuid=1275",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 3154,
                          rgt: 3159,
                          children: [],
                        },
                        {
                          id: "f2ed7750766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1270",
                          name: "库存查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2e1de90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/kcgl/kccx?menuid=1270",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 3150,
                          rgt: 3153,
                          children: [],
                        },
                        {
                          id: "f2f03670766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2051",
                          name: "按校区统计用卡量",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2e1de90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/schoolcardcount/kcschoolcardcount?menuid=2051",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 3148,
                          rgt: 3149,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f2f2ce80766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:19.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-4",
                  name: "财务清算",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 2,
                  level: 2,
                  lft: 2986,
                  rgt: 3145,
                  children: [
                    {
                      id: "f2f47c30766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:19.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-451",
                      name: "操作员表",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2f2ce80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 3115,
                      rgt: 3144,
                      children: [
                        {
                          id: "f2f629e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:19.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-175",
                          name: "操作员现金报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toopercash?menuid=175",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3136,
                          rgt: 3139,
                          children: [],
                        },
                        {
                          id: "f2f8c1f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-229",
                          name: "操作员现金统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toopercashselftrade?menuid=229",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3132,
                          rgt: 3135,
                          children: [],
                        },
                        {
                          id: "f2fae4d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-235",
                          name: "操作员非现金存款统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toposcashselftradeall?menuid=235",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3128,
                          rgt: 3131,
                          children: [],
                        },
                        {
                          id: "f2fd2ec0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-237",
                          name: "操作员非现金存款报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toposcashtotal?menuid=237",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 3124,
                          rgt: 3127,
                          children: [],
                        },
                        {
                          id: "f2ff2a90766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1751",
                          name: "操作员现金报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toopercashdwjm?menuid=1751",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 3120,
                          rgt: 3123,
                          children: [],
                        },
                        {
                          id: "f3012660766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2291",
                          name: "操作员现金统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toopercashselftradedwjm?menuid=2291",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 3116,
                          rgt: 3119,
                          children: [],
                        },
                        {
                          id: "70d98270bed011eb602305277b20c381",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-05-27T17:46:42.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-05-27T18:06:06.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-494492703883661320",
                          name: "操作员业务统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f2f47c30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tooperstatisticsrpt?menuid=494492703883661320",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 3140,
                          rgt: 3143,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f302fb20766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-452",
                      name: "自助存款报表",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2f2ce80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 3097,
                      rgt: 3114,
                      children: [
                        {
                          id: "f304cfe0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-251",
                          name: "自助存款统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f302fb20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tocashmachine?menuid=251",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3110,
                          rgt: 3113,
                          children: [],
                        },
                        {
                          id: "f3067d90766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-255",
                          name: "自助存款实时查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f302fb20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tocashmachineselftrade?menuid=255",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3106,
                          rgt: 3109,
                          children: [],
                        },
                        {
                          id: "f3082b40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-504601135181598720",
                          name: "自助存款缴款报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f302fb20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tocashmachineselfpay?menuid=504601135181598720",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3100,
                          rgt: 3105,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f30a9c40766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-453",
                      name: "系统报表",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2f2ce80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 3,
                      level: 3,
                      lft: 3063,
                      rgt: 3096,
                      children: [
                        {
                          id: "f30c9810766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1206",
                          name: "第三方支付统计明细报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tothirdpartydetail?menuid=1206",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3092,
                          rgt: 3095,
                          children: [],
                        },
                        {
                          id: "b6e1a590767311ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T15:41:33.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T15:41:47.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2017",
                          name: "余额结转报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/balanceTransferReportForms?menuid=2017",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3098,
                          rgt: 3099,
                          children: [],
                        },
                        {
                          id: "f30e6cd0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-259",
                          name: "补助统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tosubsidydetail?menuid=259",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3088,
                          rgt: 3091,
                          children: [],
                        },
                        {
                          id: "f3104190766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-263",
                          name: "交易明细报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/torpttxdetail?menuid=263",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3084,
                          rgt: 3087,
                          children: [],
                        },
                        {
                          id: "f311ef40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1194",
                          name: "第三方支付统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tothirdparty?menuid=1194",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 3080,
                          rgt: 3083,
                          children: [],
                        },
                        {
                          id: "f31375e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2057",
                          name: "余额结转报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/balanceTransferReportForms?menuid=2057",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 3076,
                          rgt: 3079,
                          children: [],
                        },
                        {
                          id: "f3154aa0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9019",
                          name: "身份余额汇总报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/statusbalancesummaryreport?menuid=9019",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 3072,
                          rgt: 3075,
                          children: [],
                        },
                        {
                          id: "f3187ef0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-488640227179630592",
                          name: "第三方对账统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tothirdpartywz?menuid=488640227179630592",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 3068,
                          rgt: 3071,
                          children: [],
                        },
                        {
                          id: "f31ac8e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2631",
                          name: "交易明细报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f30a9c40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/torpttxdetaildy?menuid=2631",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 3064,
                          rgt: 3067,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f31cc4b0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-173",
                      name: "卡务报表",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2f2ce80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 4,
                      level: 3,
                      lft: 3049,
                      rgt: 3062,
                      children: [
                        {
                          id: "f31f5cc0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-249",
                          name: "银校转账统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f31cc4b0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tobankschoolselftrade?menuid=249",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3058,
                          rgt: 3061,
                          children: [],
                        },
                        {
                          id: "f3215890766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-257",
                          name: "银校转账统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f31cc4b0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tobankschoolcash?menuid=257",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3054,
                          rgt: 3057,
                          children: [],
                        },
                        {
                          id: "f3232d50766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1278",
                          name: "自助补卡支付统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f31cc4b0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/toselfservicecard?menuid=1278",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3050,
                          rgt: 3053,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f326fde0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-181",
                      name: "商户报表",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f2f2ce80766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 5,
                      level: 3,
                      lft: 2987,
                      rgt: 3048,
                      children: [
                        {
                          id: "41b5a920807711eb867bcf56cff86721",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-03-09T09:32:06.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-03-09T09:32:23.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-183",
                          name: "商户账户报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toMerchantAccount?menuid=183",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 3038,
                          rgt: 3043,
                          children: [],
                        },
                        {
                          id: "f32920c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-186",
                          name: "商户POS汇总报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tomerchantpossum?menuid=186",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3034,
                          rgt: 3037,
                          children: [],
                        },
                        {
                          id: "41abbe10807711eb867bcf56cff86721",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-03-09T09:32:06.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-03-09T09:32:23.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-325",
                          name: "商户管理费报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tomerchantmanagert?menuid=325",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 3044,
                          rgt: 3047,
                          children: [],
                        },
                        {
                          id: "f32b43a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-187",
                          name: "商户餐次报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tomerchantmealtime?menuid=187",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 3030,
                          rgt: 3033,
                          children: [],
                        },
                        {
                          id: "f32d6680766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-486013048549675008",
                          name: "商户总账户报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tomerchantParentaccountByHNNT?menuid=486013048549675008",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 3024,
                          rgt: 3029,
                          children: [],
                        },
                        {
                          id: "f32f1430766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-188",
                          name: "商户餐次统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tomerchantmealstatistic?menuid=188",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 3020,
                          rgt: 3023,
                          children: [],
                        },
                        {
                          id: "f3311000766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1881",
                          name: "商户餐次统计报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toMerchantMealStatistichb?menuid=1881",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 3016,
                          rgt: 3019,
                          children: [],
                        },
                        {
                          id: "f3330bd0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-19980124",
                          name: "商户账户报表(是剔除交易代码或者查询交易代码)",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/toMerchantAccountNofee?menuid=19980124",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 3010,
                          rgt: 3015,
                          children: [],
                        },
                        {
                          id: "f334b980766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-19980125",
                          name: "商户管理费报表页面（sql查询的是商户汇总表）",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/report-ui/report/tomerchantmanagertSummary?menuid=19980125",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 3004,
                          rgt: 3009,
                          children: [],
                        },
                        {
                          id: "f3366730766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670062",
                          name: "食堂商户窗口报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/canteenbindmerchant?menuid=1670062",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 3000,
                          rgt: 3003,
                          children: [],
                        },
                        {
                          id: "f33814e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-17712",
                          name: "商户套餐报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tomerchantcafeteria?menuid=17712",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 2996,
                          rgt: 2999,
                          children: [],
                        },
                        {
                          id: "f339c290766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-3251",
                          name: "商户管理费报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tomerchantmanagertdy?menuid=3251",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 2992,
                          rgt: 2995,
                          children: [],
                        },
                        {
                          id: "f33b4930766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-185",
                          name: "商户POS报表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f326fde0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/report/tomerchantpos?menuid=185",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 2988,
                          rgt: 2991,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f33d6c10766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:20.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-3",
                  name: "虚拟卡管理",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 3,
                  level: 2,
                  lft: 2872,
                  rgt: 2985,
                  children: [
                    {
                      id: "f33f40d0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-140",
                      name: "电子券管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f33d6c10766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2957,
                      rgt: 2984,
                      children: [
                        {
                          id: "f341d8e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-392",
                          name: "电子券转赠查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f33f40d0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/queryGiftQiving?menuid=392",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2980,
                          rgt: 2983,
                          children: [],
                        },
                        {
                          id: "f3453440766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-391",
                          name: "电子券信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f33f40d0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/queryETicket?menuid=391",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2976,
                          rgt: 2979,
                          children: [],
                        },
                        {
                          id: "f347a540766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2115",
                          name: "电子券审核",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f33f40d0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/checkEticketInfo?menuid=2115",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2970,
                          rgt: 2975,
                          children: [],
                        },
                        {
                          id: "f34a8b70766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11112",
                          name: "单位电子券审核",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f33f40d0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/queryUnitTicketExamine?menuid=11112",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2966,
                          rgt: 2969,
                          children: [],
                        },
                        {
                          id: "f34cae50766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11113",
                          name: "单位电子券生成",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f33f40d0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/queryUnitTicketCreate?menuid=11113",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2962,
                          rgt: 2965,
                          children: [],
                        },
                        {
                          id: "f34f6d70766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11114",
                          name: "单位电子券发放",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f33f40d0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/queryUnitTicketSend?menuid=11114",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2958,
                          rgt: 2961,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f351de70766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2003",
                      name: "虚拟卡卡包管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f33d6c10766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2917,
                      rgt: 2956,
                      children: [
                        {
                          id: "f3538c20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2010",
                          name: "虚拟卡解绑",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/toqueryVirtualunbind?menuid=2010",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2952,
                          rgt: 2955,
                          children: [],
                        },
                        {
                          id: "f35587f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2007",
                          name: "支付宝栏位信息管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/tovirtuAlipayHurdleManage?menuid=2007",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2944,
                          rgt: 2951,
                          children: [],
                        },
                        {
                          id: "f3575cb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2009",
                          name: "创建开卡链接",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/toCreateOpenCardLink?menuid=2009",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2942,
                          rgt: 2943,
                          children: [],
                        },
                        {
                          id: "f3595880766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2008",
                          name: "白名单管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/toWhiteListMange?menuid=2008",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2940,
                          rgt: 2941,
                          children: [],
                        },
                        {
                          id: "f35b0630766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2006",
                          name: "微信栏位信息管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/tovirtuweChatHurdleManage?menuid=2006",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2932,
                          rgt: 2939,
                          children: [],
                        },
                        {
                          id: "f35d0200766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2005",
                          name: "卡包图片信息管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/toquerycpphotoinfoList?menuid=2005",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2924,
                          rgt: 2931,
                          children: [],
                        },
                        {
                          id: "f35ed6c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2004",
                          name: "卡包信息管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f351de70766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/vcmanage/toquerycpcardpackageList?menuid=2004",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2918,
                          rgt: 2923,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f360ab80766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-138",
                      name: "虚拟卡信息管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f33d6c10766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 3,
                      level: 3,
                      lft: 2873,
                      rgt: 2916,
                      children: [
                        {
                          id: "f3628040766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-473424982232403968",
                          name: "基础账户充值",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/qrcode/baseAccountRecharge?menuid=473424982232403968",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2912,
                          rgt: 2915,
                          children: [],
                        },
                        {
                          id: "f3642df0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-475616834008256513",
                          name: "虚拟卡档案信息修改",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/qrcode/editQrcodeUserinfo?menuid=475616834008256513",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2910,
                          rgt: 2911,
                          children: [],
                        },
                        {
                          id: "f365dba0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-393",
                          name: "推送虚拟卡绑定信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eticket/pushPaycodeBind?menuid=393",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2908,
                          rgt: 2909,
                          children: [],
                        },
                        {
                          id: "f3678950766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-381",
                          name: "付款码开通",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/qrcode/openup?menuid=381",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2902,
                          rgt: 2907,
                          children: [],
                        },
                        {
                          id: "f3693700766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-382",
                          name: "付款码信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/qrcode/queryQRcode?menuid=382",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2890,
                          rgt: 2901,
                          children: [],
                        },
                        {
                          id: "f36abda0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-383",
                          name: "人脸应用注册",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/face/register?menuid=383",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2884,
                          rgt: 2889,
                          children: [],
                        },
                        {
                          id: "f36cb970766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-384",
                          name: "人脸应用信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f360ab80766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/face/queryFace?menuid=384",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2874,
                          rgt: 2883,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f36eb540766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:20.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-1",
                  name: "用户管理",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eod!openTrjnTrade.action?menuid=1",
                  target: "iframe",
                  order: 4,
                  level: 2,
                  lft: 2818,
                  rgt: 2871,
                  children: [
                    {
                      id: "f370b110766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2118",
                      name: "照片信息管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f36eb540766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2859,
                      rgt: 2870,
                      children: [
                        {
                          id: "f372fb00766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2119",
                          name: "照片参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f370b110766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/photo/photoparam/photoparam?menuid=2119",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2862,
                          rgt: 2869,
                          children: [],
                        },
                        {
                          id: "f3751de0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2120",
                          name: "照片管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f370b110766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/photo/photomanager/photomanager?menuid=2120",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2860,
                          rgt: 2861,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f3778ee0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-92",
                      name: "用户信息管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f36eb540766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2819,
                      rgt: 2858,
                      children: [
                        {
                          id: "f379ffe0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2082",
                          name: "未开户档案信息修改",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3778ee0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/user/userinfo/unopenaccountlist?menuid=2082",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2852,
                          rgt: 2857,
                          children: [],
                        },
                        {
                          id: "f37ce610766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-475616834008256514",
                          name: "未开户档案信息修改",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3778ee0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/user/userinfo/unopenaccountlist?menuid=475616834008256514",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2836,
                          rgt: 2851,
                          children: [],
                        },
                        {
                          id: "f37fcc40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-121",
                          name: "档案信息修改",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3778ee0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/user/userinfo/edituserinfo?menuid=121",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2834,
                          rgt: 2835,
                          children: [],
                        },
                        {
                          id: "f3830090766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-123",
                          name: "档案信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3778ee0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/user/userinfo/userinfo?menuid=123",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2820,
                          rgt: 2833,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f38598a0766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:20.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-5",
                  name: "综合消费",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 5,
                  level: 2,
                  lft: 2750,
                  rgt: 2817,
                  children: [
                    {
                      id: "f38857c0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:20.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-189",
                      name: "消费设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f38598a0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2775,
                      rgt: 2816,
                      children: [
                        {
                          id: "f38ac8c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-193",
                          name: "设备管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f38857c0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/posdevice/queryposdevicelistbyposdatadetail?menuid=193",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2798,
                          rgt: 2815,
                          children: [],
                        },
                        {
                          id: "f38d39c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-195",
                          name: "设备归属",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f38857c0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/devicebelong/querydevicebelonglist?menuid=195",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2788,
                          rgt: 2797,
                          children: [],
                        },
                        {
                          id: "f38ff8e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:20.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1166",
                          name: "消费方式限制",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f38857c0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/posconsumrules/queryposconsumrules?menuid=1166",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2782,
                          rgt: 2787,
                          children: [],
                        },
                        {
                          id: "f39269e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1161",
                          name: "POS身份绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f38857c0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/posdevice/posbelongposition?menuid=1161",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2776,
                          rgt: 2781,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f394dae0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-1670052",
                      name: "食堂商户绑定",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f38598a0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2751,
                      rgt: 2774,
                      children: [
                        {
                          id: "f39772f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670058",
                          name: "商户窗口绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f394dae0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/posdevice/merchantbinwindow?menuid=1670058",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2768,
                          rgt: 2773,
                          children: [],
                        },
                        {
                          id: "f39a3210766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670051",
                          name: "食堂商户绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f394dae0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/posdevice/canteenbinmerchant?menuid=1670051",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2760,
                          rgt: 2767,
                          children: [],
                        },
                        {
                          id: "f39c7c00766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670055",
                          name: "食堂窗口管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f394dae0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/posdevice/windowAdministration?menuid=1670055",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2752,
                          rgt: 2759,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f3a10fe0766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:21.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-2",
                  name: "卡务管理",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eod!openTrjnTrade.action?menuid=2",
                  target: "iframe",
                  order: 6,
                  level: 2,
                  lft: 2404,
                  rgt: 2749,
                  children: [
                    {
                      id: "f3a46b40766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-111",
                      name: "卡户特殊业务",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2693,
                      rgt: 2748,
                      children: [
                        {
                          id: "f3a6b530766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-115",
                          name: "卡户冲账",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/washbank/washbank?menuid=115",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2740,
                          rgt: 2745,
                          children: [],
                        },
                        {
                          id: "f3aafaf0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-243",
                          name: "卡户取款",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/drawmoney/drawmoney?menuid=243",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2738,
                          rgt: 2739,
                          children: [],
                        },
                        {
                          id: "f3ae0830766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-906",
                          name: "异常账户余额查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/exceptionbalance/exceptionbalance?menuid=906",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2736,
                          rgt: 2737,
                          children: [],
                        },
                        {
                          id: "f3b07930766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1210",
                          name: "水控复采文件处理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/reprocessG401Trade/openReprocessG401TradePage?menuid=1210",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2734,
                          rgt: 2735,
                          children: [],
                        },
                        {
                          id: "f3b2c320766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-666",
                          name: "遗失卡管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/losecardmanage/losecardmanage?menuid=666",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2728,
                          rgt: 2733,
                          children: [],
                        },
                        {
                          id: "f3b6bac0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2078",
                          name: "现金充值异常处理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/cashrecharge/cashrecharge?menuid=2078",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2724,
                          rgt: 2727,
                          children: [],
                        },
                        {
                          id: "f3b952d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11161",
                          name: "银校流水重新推送",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/bankselftrade/bankselftradeexceptionhandle?menuid=11161",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2720,
                          rgt: 2723,
                          children: [],
                        },
                        {
                          id: "f3bbc3d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-15913",
                          name: "卡务操作员POS支付绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/cardpos/cardpospaybind?menuid=15913",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 2712,
                          rgt: 2719,
                          children: [],
                        },
                        {
                          id: "f3bf1f30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-117",
                          name: "遗失卡管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/losecardmanage/losecardmanage?menuid=117",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 2706,
                          rgt: 2711,
                          children: [],
                        },
                        {
                          id: "f3c16920766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-116",
                          name: "异常流水处理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/exceptiontrjn/exceptiontrjn?menuid=116",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 2702,
                          rgt: 2705,
                          children: [],
                        },
                        {
                          id: "f3c3b310766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-330",
                          name: "支票/转账单管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cardbillinfo/cardbillinfo?menuid=330",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 2696,
                          rgt: 2701,
                          children: [],
                        },
                        {
                          id: "f3c64b20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-335",
                          name: "CPU卡解锁",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3a46b40766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/csm/cpuunlock/cpuunlock?menuid=335",
                          target: "iframe",
                          order: 13,
                          level: 4,
                          lft: 2694,
                          rgt: 2695,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f3c86e00766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-157",
                      name: "补助管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2637,
                      rgt: 2692,
                      children: [
                        {
                          id: "f3ca42c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-159",
                          name: "补助查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/subsidy/sidy/sidy?menuid=159",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2690,
                          rgt: 2691,
                          children: [],
                        },
                        {
                          id: "f3cc8cb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-161",
                          name: "单笔发放补助",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/subsidy/sidy/subsidyout?menuid=161",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2686,
                          rgt: 2689,
                          children: [],
                        },
                        {
                          id: "f3ce6170766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-166",
                          name: "补助详情查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/subsidy/subsidydetailmanage/subsidydetailmanage?menuid=166",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2676,
                          rgt: 2685,
                          children: [],
                        },
                        {
                          id: "f3d05d40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2101",
                          name: "单笔发放补助提交",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/subsidy/sidy/subsidycommit?menuid=2101",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2662,
                          rgt: 2675,
                          children: [],
                        },
                        {
                          id: "f3d25910766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2103",
                          name: "发放补助审核",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/subsidy/sidy/subsidycheck?menuid=2103",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2650,
                          rgt: 2661,
                          children: [],
                        },
                        {
                          id: "f3d4ca10766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-15911",
                          name: "餐补管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/mealSubsidyDef/queryMealSubsidyDefList?menuid=15911",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2642,
                          rgt: 2649,
                          children: [],
                        },
                        {
                          id: "f3d71400766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-15912",
                          name: "餐补统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/mealSubsidyDef/mealSubsidyDefStatistics?menuid=15912",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2640,
                          rgt: 2641,
                          children: [],
                        },
                        {
                          id: "f3d9fa30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670039",
                          name: "按身份导出",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3c86e00766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/Subsidy/SubsidyImportByPosition?menuid=1670039",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 2638,
                          rgt: 2639,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f3dc6b30766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-1670048",
                      name: "业务财务结算",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 3,
                      level: 3,
                      lft: 2627,
                      rgt: 2636,
                      children: [
                        {
                          id: "f3dedc30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670043",
                          name: "操作员现金统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3dc6b30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/wangreport-ui/report/toopercashselftrade/moduleid?moduleid=2?menuid=1670043",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2632,
                          rgt: 2635,
                          children: [],
                        },
                        {
                          id: "f3e21080766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670044",
                          name: "操作员非现金存款统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3dc6b30766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/service/wangreport-ui/report/toposcashselftradeall/moduleid?moduleid=2?menuid=1670044",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2628,
                          rgt: 2631,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f3e43360766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-950",
                      name: "销户退款",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 4,
                      level: 3,
                      lft: 2621,
                      rgt: 2626,
                      children: [
                        {
                          id: "f3e62f30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-951",
                          name: "销户支付宝登记查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3e43360766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/closeaccount/alipaylossaccountlist?menuid=951",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2622,
                          rgt: 2625,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f3e8c740766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2300",
                      name: "教职工补助",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 5,
                      level: 3,
                      lft: 2605,
                      rgt: 2620,
                      children: [
                        {
                          id: "f3eb5f50766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670040",
                          name: "补助名单导出",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3e8c740766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/Subsidy/SubsidyListExport?menuid=1670040",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2616,
                          rgt: 2619,
                          children: [],
                        },
                        {
                          id: "f3eda940766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2301",
                          name: "教职工补助导入",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3e8c740766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/subsidy/jzgbz/jzgbzdr?menuid=2301",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2606,
                          rgt: 2615,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f3efcc20766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-119",
                      name: "卡户信息管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 6,
                      level: 3,
                      lft: 2527,
                      rgt: 2604,
                      children: [
                        {
                          id: "f3f30070766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-239",
                          name: "账户详细信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/userinfo/detailuserinfolist?menuid=239",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2590,
                          rgt: 2601,
                          children: [],
                        },
                        {
                          id: "f3f5bf90766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2056",
                          name: "余额结转信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/selftraed/balanceturnlist?menuid=2056",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2588,
                          rgt: 2589,
                          children: [],
                        },
                        {
                          id: "f3f857a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2308",
                          name: "预约排号信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/booking/bookinggetnumlist?menuid=2308",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2586,
                          rgt: 2587,
                          children: [],
                        },
                        {
                          id: "f3fb3dd0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-522596496089157650",
                          name: "主副账户信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/baseaccountinforelation/tobaseaccountinforelationlist?menuid=522596496089157650",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2582,
                          rgt: 2585,
                          children: [],
                        },
                        {
                          id: "f3fe2400766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-522596496089157640",
                          name: "银校绑定导出全部",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/expBindBank/expBindBank?menuid=522596496089157640",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2580,
                          rgt: 2581,
                          children: [],
                        },
                        {
                          id: "f4015850766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-5225964960891538",
                          name: "手工同步人员信息",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/manualsync/syncuserinfo?menuid=5225964960891538",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2578,
                          rgt: 2579,
                          children: [],
                        },
                        {
                          id: "b6e4b2d0767311ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T15:41:33.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T15:41:47.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2016",
                          name: "余额结转信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/selftraed/balanceturnlist?menuid=2016",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2602,
                          rgt: 2603,
                          children: [],
                        },
                        {
                          id: "f4037b30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-5225964960891541",
                          name: "二维码图片同步",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/manualsync/syncewm?menuid=5225964960891541",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2576,
                          rgt: 2577,
                          children: [],
                        },
                        {
                          id: "f4059e10766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2127",
                          name: "休眠账户信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/selftraed/dormancyuserinfolist?menuid=2127",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 2572,
                          rgt: 2575,
                          children: [],
                        },
                        {
                          id: "f4080f10766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9100",
                          name: "账户透支用户查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/accountOverdraft/list?menuid=9100",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 2566,
                          rgt: 2571,
                          children: [],
                        },
                        {
                          id: "f40af540766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-19980123",
                          name: "销户退款情况查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/CancelledRefund/cancelledRefundInfo?menuid=19980123",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 2558,
                          rgt: 2565,
                          children: [],
                        },
                        {
                          id: "f40d6640766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-10888",
                          name: "微信用户信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/weChatInfo/weChatUserList?menuid=10888",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 2552,
                          rgt: 2557,
                          children: [],
                        },
                        {
                          id: "f4104c70766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-125",
                          name: "流水信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/selftraed/selftraedlist?menuid=125",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 2540,
                          rgt: 2551,
                          children: [],
                        },
                        {
                          id: "f4130b90766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-127",
                          name: "换卡登记查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/changehavecard/changecardlist?menuid=127",
                          target: "iframe",
                          order: 13,
                          level: 4,
                          lft: 2538,
                          rgt: 2539,
                          children: [],
                        },
                        {
                          id: "f41618d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-133",
                          name: "销户登记查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/closeaccount/lossaccountlist?menuid=133",
                          target: "iframe",
                          order: 14,
                          level: 4,
                          lft: 2534,
                          rgt: 2537,
                          children: [],
                        },
                        {
                          id: "f418ff00766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-135",
                          name: "费用登记查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/feeregist/feeregist?menuid=135",
                          target: "iframe",
                          order: 15,
                          level: 4,
                          lft: 2532,
                          rgt: 2533,
                          children: [],
                        },
                        {
                          id: "f41c3350766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-129",
                          name: "开户登记查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/openaccount/openaccountlist?menuid=129",
                          target: "iframe",
                          order: 16,
                          level: 4,
                          lft: 2530,
                          rgt: 2531,
                          children: [],
                        },
                        {
                          id: "f41ea450766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-368",
                          name: "开户信息统计",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f3efcc20766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/openaccount/openaccountinfolist?menuid=368",
                          target: "iframe",
                          order: 17,
                          level: 4,
                          lft: 2528,
                          rgt: 2529,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f4211550766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:21.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-141",
                      name: "业务批操作",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 7,
                      level: 3,
                      lft: 2465,
                      rgt: 2526,
                      children: [
                        {
                          id: "f423fb80766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-149",
                          name: "有档案批量开户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/openaccountagain/openaccountagain?menuid=149",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2522,
                          rgt: 2525,
                          children: [],
                        },
                        {
                          id: "f42708c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:21.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-156",
                          name: "批量解挂/解冻",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/reportloss/openLossAndFreeze?menuid=156",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2508,
                          rgt: 2521,
                          children: [],
                        },
                        {
                          id: "f42a8b30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-148",
                          name: "档案批量开户打印",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/openaccountbatch/openaccountbatchAndPrint?menuid=148",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2504,
                          rgt: 2507,
                          children: [],
                        },
                        {
                          id: "f42e5bc0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-478508653490606081",
                          name: "批量打印图片文字",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/openaccountbatch/batchAndPrint?menuid=478508653490606081",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2502,
                          rgt: 2503,
                          children: [],
                        },
                        {
                          id: "f43141f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-147",
                          name: "档案批量开户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/openaccountbatch/openaccountbatch?menuid=147",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2494,
                          rgt: 2501,
                          children: [],
                        },
                        {
                          id: "f4342820766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-143",
                          name: "批量导入导出",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/cardbatchoperat/cardbatchoperat?menuid=143",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2484,
                          rgt: 2493,
                          children: [],
                        },
                        {
                          id: "f4370e50766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-151",
                          name: "批量预销户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/cardbatchloss/cardbatchloss?menuid=151",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2478,
                          rgt: 2483,
                          children: [],
                        },
                        {
                          id: "f43bc940766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-153",
                          name: "批量销户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4211550766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/batch/cardbatchcel/cardbatchcel?menuid=153",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 2468,
                          rgt: 2477,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f43e8860766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:22.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-93",
                      name: "卡户日常业务",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f3a10fe0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 8,
                      level: 3,
                      lft: 2405,
                      rgt: 2464,
                      children: [
                        {
                          id: "f44195a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-109",
                          name: "有卡重置密码",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/modifycardpwd/modifycardpwd?menuid=109",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2460,
                          rgt: 2461,
                          children: [],
                        },
                        {
                          id: "f4451810766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1204",
                          name: "手动补卡",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/changehavecard/manualpatchcardlist?menuid=1204",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2456,
                          rgt: 2459,
                          children: [],
                        },
                        {
                          id: "f449abf0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-102",
                          name: "有卡换卡",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/changehavecard/changehavecard?menuid=102",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2454,
                          rgt: 2455,
                          children: [],
                        },
                        {
                          id: "f44d5570766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-98",
                          name: "POS支付存款",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/savemoney/saveMoneyPOS?menuid=98",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2452,
                          rgt: 2453,
                          children: [],
                        },
                        {
                          id: "f45062b0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2023",
                          name: "条形码开户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/openaccount/barcode?menuid=2023",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2466,
                          rgt: 2467,
                          children: [],
                        },
                        {
                          id: "f45348e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-106",
                          name: "无卡换卡打印",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/changehavecard/changecardAndPrint?menuid=106",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2448,
                          rgt: 2451,
                          children: [],
                        },
                        {
                          id: "f456a440766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2307",
                          name: "手动余额结转",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/balancecarry/manualcarryover?menuid=2307",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2446,
                          rgt: 2447,
                          children: [],
                        },
                        {
                          id: "f45a26b0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-103",
                          name: "无卡换卡",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/changehavecard/changecard?menuid=103",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 2442,
                          rgt: 2445,
                          children: [],
                        },
                        {
                          id: "f45d8210766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-97",
                          name: "现金存款",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/savemoney/saveMoneyXj?menuid=97",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 2440,
                          rgt: 2441,
                          children: [],
                        },
                        {
                          id: "f4610480766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-247",
                          name: "无卡重置密码",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/modifycardpwd/nocardmodifypwd?menuid=247",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 2438,
                          rgt: 2439,
                          children: [],
                        },
                        {
                          id: "f46438d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-101",
                          name: "挂失解挂",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/reportloss/reportloss?menuid=101",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 2430,
                          rgt: 2437,
                          children: [],
                        },
                        {
                          id: "f4676d20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-94",
                          name: "开户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/openaccount/getopenaccount?menuid=94",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 2428,
                          rgt: 2429,
                          children: [],
                        },
                        {
                          id: "43269e40807711eb867bcf56cff86721",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-03-09T09:32:08.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-03-09T09:32:24.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-95",
                          name: "条形码开户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/openaccount/barcode?menuid=95",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 2462,
                          rgt: 2463,
                          children: [],
                        },
                        {
                          id: "f46a7a60766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-99",
                          name: "非现金存款",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/savemoneyzp/savemoneyzp?menuid=99",
                          target: "iframe",
                          order: 13,
                          level: 4,
                          lft: 2426,
                          rgt: 2427,
                          children: [],
                        },
                        {
                          id: "f46d87a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-105",
                          name: "有卡销户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/closeaccount/closeaccount?menuid=105",
                          target: "iframe",
                          order: 14,
                          level: 4,
                          lft: 2424,
                          rgt: 2425,
                          children: [],
                        },
                        {
                          id: "f470bbf0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-107",
                          name: "无卡销户",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f43e8860766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/card/closeaccount/nocardcloseaccount?menuid=107",
                          target: "iframe",
                          order: 15,
                          level: 4,
                          lft: 2406,
                          rgt: 2423,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f4746570766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:22.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-6",
                  name: "节水控制",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 7,
                  level: 2,
                  lft: 2328,
                  rgt: 2403,
                  children: [
                    {
                      id: "f4794770766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:22.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-199",
                      name: "水控设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4746570766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2357,
                      rgt: 2400,
                      children: [
                        {
                          id: "f47c2da0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-203",
                          name: "设备管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4794770766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/waterdevice/querywaterdevicelistbyposdetail?menuid=203",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2380,
                          rgt: 2399,
                          children: [],
                        },
                        {
                          id: "f47f3ae0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-205",
                          name: "设备归属",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4794770766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/waterdevicebelong/querywaterdevicebelonglist?menuid=205",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2372,
                          rgt: 2379,
                          children: [],
                        },
                        {
                          id: "f4822110766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-207",
                          name: "特殊水价设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4794770766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/waterparam/querywaterparamlist?menuid=207",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2364,
                          rgt: 2371,
                          children: [],
                        },
                        {
                          id: "f484e030766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-403",
                          name: "pos身份控制",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4794770766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/waterpcodebind/querywaterbindlist?menuid=403",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2358,
                          rgt: 2363,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "b6f26e70767311ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T15:41:33.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T15:41:47.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2019",
                      name: "浴室设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4746570766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "http://dk-ykt.paas.newcapec.cn",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2401,
                      rgt: 2402,
                      children: [
                        {
                          id: "bc028350767311ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T15:41:41.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T15:41:51.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2029",
                          name: "无卡水控消费流水查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "b6f26e70767311ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/bathroom/getwaterconsume?menuid=2029",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2418,
                          rgt: 2419,
                          children: [],
                        },
                        {
                          id: "b6eb1b70767311ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T15:41:33.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T15:41:47.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2021",
                          name: "POS身份绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "b6f26e70767311ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/bathroomSettings/bathroomPosbinding?menuid=2021",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2416,
                          rgt: 2417,
                          children: [],
                        },
                        {
                          id: "b6eeec00767311ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T15:41:33.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T15:41:47.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2020",
                          name: "浴室管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "b6f26e70767311ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/bathroomSettings/bathroommanagement?menuid=2020",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2410,
                          rgt: 2415,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f48862a0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:22.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2068",
                      name: "浴室设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4746570766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2329,
                      rgt: 2356,
                      children: [
                        {
                          id: "f48b6fe0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2047",
                          name: "浴室预约信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f48862a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/bathroom/getwaterorder?menuid=2047",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2350,
                          rgt: 2351,
                          children: [],
                        },
                        {
                          id: "f4911530766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2070",
                          name: "浴室商户设备绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f48862a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/bathroomSettings/bathroomPosbinding?menuid=2070",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2344,
                          rgt: 2349,
                          children: [],
                        },
                        {
                          id: "f493fb60766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2069",
                          name: "浴室管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f48862a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/bathroomSettings/bathroommanagement?menuid=2069",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2336,
                          rgt: 2343,
                          children: [],
                        },
                        {
                          id: "f4972fb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2124",
                          name: "爽约记录管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f48862a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/breakfaith/queryWaterBreakFaithList?menuid=2124",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2352,
                          rgt: 2355,
                          children: [],
                        },
                        {
                          id: "f49a15e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2080",
                          name: "POS忙闲状态查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f48862a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/waterBusyleisure/queryWaterBusyLeisureInfo?menuid=2080",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2332,
                          rgt: 2335,
                          children: [],
                        },
                        {
                          id: "f49d7140766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2126",
                          name: "无卡水控消费流水查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f48862a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/bathroom/getwaterconsume?menuid=2126",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2330,
                          rgt: 2331,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f4a364b0766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:22.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-7",
                  name: "自助洗衣",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 8,
                  level: 2,
                  lft: 2300,
                  rgt: 2327,
                  children: [
                    {
                      id: "f4a7f890766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:22.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-209",
                      name: "洗衣设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4a364b0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2301,
                      rgt: 2326,
                      children: [
                        {
                          id: "f4abf030766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-213",
                          name: "设备管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4a7f890766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfwashdevice/queryselfwashdevicelistbyposdetail?menuid=213",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2316,
                          rgt: 2325,
                          children: [],
                        },
                        {
                          id: "f4b035f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-215",
                          name: "设备归属",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4a7f890766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfwashdevicebelong/queryselfwashdevicebelonglist?menuid=215",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2308,
                          rgt: 2315,
                          children: [],
                        },
                        {
                          id: "f4b3b860766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-217",
                          name: "洗衣POS身份控制",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4a7f890766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfwashparam/selfwashbelongposition?menuid=217",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2302,
                          rgt: 2307,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f4b6ecb0766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:22.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-8",
                  name: "自助开水",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 9,
                  level: 2,
                  lft: 2256,
                  rgt: 2299,
                  children: [
                    {
                      id: "f4b9f9f0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:22.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-219",
                      name: "开水设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4b6ecb0766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2257,
                      rgt: 2298,
                      children: [
                        {
                          id: "f4bce020766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-221",
                          name: "站点设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4b9f9f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfwater/queryselfwaterstationlist?menuid=221",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2290,
                          rgt: 2297,
                          children: [],
                        },
                        {
                          id: "f4bf9f40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:22.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-223",
                          name: "设备管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4b9f9f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfwaterdevice/queryselfwaterdevicelistbyposdetail?menuid=223",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2274,
                          rgt: 2289,
                          children: [],
                        },
                        {
                          id: "f4c2ac80766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-225",
                          name: "设备归属",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4b9f9f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfdevicebelong/queryselfdevicebelonglist?menuid=225",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2266,
                          rgt: 2273,
                          children: [],
                        },
                        {
                          id: "f4c62ef0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-227",
                          name: "参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4b9f9f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/selfwaterparam/queryselfwaterparamlist?menuid=227",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2258,
                          rgt: 2265,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "f4c91520766711ebc1efeeb47ed3ca72",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-24T14:17:23.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-02-24T14:34:52.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "v8-9",
                  name: "后台管理",
                  memo: null,
                  status: "1",
                  applicationId: "09f63db0646111eba70f7fae370101e5",
                  parentId: "f2c44470766711ebc1efeeb47ed3ca72",
                  type: "2",
                  icon: null,
                  origin: "",
                  url: null,
                  target: "iframe",
                  order: 10,
                  level: 2,
                  lft: 1694,
                  rgt: 2255,
                  children: [
                    {
                      id: "f4ccbea0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-260",
                      name: "缴费管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 1,
                      level: 3,
                      lft: 2231,
                      rgt: 2254,
                      children: [
                        {
                          id: "f4cfa4d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-270",
                          name: "缴费设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4ccbea0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/payset/querylevelpayset?menuid=270",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2240,
                          rgt: 2253,
                          children: [],
                        },
                        {
                          id: "f4d37560766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-280",
                          name: "缴费人员管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4ccbea0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/payuser/querylevelpayuserinfo?menuid=280",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2232,
                          rgt: 2239,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f4d65b90766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-124",
                      name: "产品管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 2,
                      level: 3,
                      lft: 2209,
                      rgt: 2230,
                      children: [
                        {
                          id: "f4d968d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-126",
                          name: "产品管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4d65b90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/product/manage?menuid=126",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2222,
                          rgt: 2229,
                          children: [],
                        },
                        {
                          id: "f4e80ed0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9017",
                          name: "商户绑定产品",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4d65b90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/product/merchantmanage?menuid=9017",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2216,
                          rgt: 2221,
                          children: [],
                        },
                        {
                          id: "f4eb6a30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9016",
                          name: "用户绑定产品",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4d65b90766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/product/usermanage?menuid=9016",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2210,
                          rgt: 2215,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f4effe10766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-1215",
                      name: "记账管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 3,
                      level: 3,
                      lft: 2179,
                      rgt: 2208,
                      children: [
                        {
                          id: "f4f50720766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1231",
                          name: "凭证字设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4effe10766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/financevouchertype/queryfinancevouchertype?menuid=1231",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2200,
                          rgt: 2207,
                          children: [],
                        },
                        {
                          id: "f4f7ed50766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1235",
                          name: "录凭证",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4effe10766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/financevoucher/addfinancevoucher?menuid=1235",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2196,
                          rgt: 2199,
                          children: [],
                        },
                        {
                          id: "f4fb6fc0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1237",
                          name: "科目交易配置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4effe10766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/financesubjectconfig/queryfinancesubjectconfig?menuid=1237",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2188,
                          rgt: 2195,
                          children: [],
                        },
                        {
                          id: "f4fe2ee0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1227",
                          name: "币别设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f4effe10766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/financecurrency/queryfinancecurrency?menuid=1227",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2180,
                          rgt: 2187,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f5011510766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-2140",
                      name: "疫情进校管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/water/breakfaith/queryWaterBreakFaithList?menuid=2140",
                      target: "iframe",
                      order: 4,
                      level: 3,
                      lft: 2167,
                      rgt: 2178,
                      children: [
                        {
                          id: "f503ad20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2142",
                          name: "进校人员记录查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5011510766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysepidemicsituationinfo/querysysepidemicsituationinout?menuid=2142",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2176,
                          rgt: 2177,
                          children: [],
                        },
                        {
                          id: "f5070880766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2141",
                          name: "进校人员名单查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5011510766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysepidemicsituationinfo/querysysepidemicsituationinfo?menuid=2141",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2168,
                          rgt: 2175,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f509eeb0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-9030",
                      name: "人脸认证配置管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 5,
                      level: 3,
                      lft: 2135,
                      rgt: 2166,
                      children: [
                        {
                          id: "f50c5fb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9031",
                          name: "人脸设备组设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f509eeb0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/faceauth/toFaceDriveTypeInfo?menuid=9031",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2158,
                          rgt: 2165,
                          children: [],
                        },
                        {
                          id: "f510cc80766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9032",
                          name: "人脸人员组设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f509eeb0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/faceauth/toFacePersonInfo?menuid=9032",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2148,
                          rgt: 2157,
                          children: [],
                        },
                        {
                          id: "f515d590766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9045",
                          name: "人脸人员组归属",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f509eeb0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/faceauth/toFacePersonInfoBind?menuid=9045",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2142,
                          rgt: 2147,
                          children: [],
                        },
                        {
                          id: "f51a6970766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9036",
                          name: "人脸设备归属",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f509eeb0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/faceauth/toFaceDriveBind?menuid=9036",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2136,
                          rgt: 2141,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f522f4f0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-930",
                      name: "信用管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 6,
                      level: 3,
                      lft: 2119,
                      rgt: 2134,
                      children: [
                        {
                          id: "f527fe00766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-931",
                          name: "信用额度设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f522f4f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/credit/creditmanage/querycreditdef?menuid=931",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2126,
                          rgt: 2133,
                          children: [],
                        },
                        {
                          id: "f52abd20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-932",
                          name: "信用额度调整",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f522f4f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/credit/creditmanage/adjustcreditdef?menuid=932",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2122,
                          rgt: 2125,
                          children: [],
                        },
                        {
                          id: "f52d5530766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-933",
                          name: "风险预警",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f522f4f0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/credit/creditmanage/warncreditrisk?menuid=933",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2120,
                          rgt: 2121,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f5303b60766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:23.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-21",
                      name: "运维管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 7,
                      level: 3,
                      lft: 1931,
                      rgt: 2118,
                      children: [
                        {
                          id: "f533e4e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-297",
                          name: "操作员身份绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/userpcdbind/querysysuserpcdbind?menuid=297",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2106,
                          rgt: 2113,
                          children: [],
                        },
                        {
                          id: "f5371930766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1188",
                          name: "银校对账明细",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/checkAccount/checkAccountDetail?menuid=1188",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2098,
                          rgt: 2105,
                          children: [],
                        },
                        {
                          id: "f53ac2b0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1200",
                          name: "管理卡管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/managecard/querymanagecardlist?menuid=1200",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 2090,
                          rgt: 2097,
                          children: [],
                        },
                        {
                          id: "f53e4520766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-346",
                          name: "组合接口管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/configmanage/queryservicegroupconfig?menuid=346",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 2082,
                          rgt: 2089,
                          children: [],
                        },
                        {
                          id: "f541a080766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-347",
                          name: "子接口管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/configmanage/queryservicesubconfig?menuid=347",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 2074,
                          rgt: 2081,
                          children: [],
                        },
                        {
                          id: "f544d4d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2063",
                          name: "自助存款结账",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eod/saveSettleAcc?menuid=2063",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 2072,
                          rgt: 2073,
                          children: [],
                        },
                        {
                          id: "f547e210766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11201",
                          name: "待办任务列表",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/base/taskList?menuid=11201",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 2070,
                          rgt: 2071,
                          children: [],
                        },
                        {
                          id: "f54b1660766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11901",
                          name: "黑名单信息查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cim/userinfo/cardblacklist?menuid=11901",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 2066,
                          rgt: 2069,
                          children: [],
                        },
                        {
                          id: "f54dfc90766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-521564014178865152",
                          name: "门户公告管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/webportal/querynoticelist?menuid=521564014178865152",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 2056,
                          rgt: 2065,
                          children: [],
                        },
                        {
                          id: "f550bbb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-11903",
                          name: "终端黑名单管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/terminalBlack/queryTerminalBlack?menuid=11903",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 2052,
                          rgt: 2055,
                          children: [],
                        },
                        {
                          id: "f55353c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-522596496089157644",
                          name: "设备标签绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/devicelabelbinding/devicelist?menuid=522596496089157644",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 2046,
                          rgt: 2051,
                          children: [],
                        },
                        {
                          id: "f55612e0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:23.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-521564014178865153",
                          name: "门户文件上传",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/webportal/querynoticelist?menuid=521564014178865153",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 2042,
                          rgt: 2045,
                          children: [
                            {
                              id: "f558d200766711ebc1efeeb47ed3ca72",
                              companyId: "1",
                              deleted: false,
                              addAccount: "smartadmin",
                              addTime: "2021-02-24T14:17:23.000+0800",
                              editAccount: "smartadmin",
                              editTime: "2021-02-24T14:34:52.000+0800",
                              deleteAccount: null,
                              deleteTime: null,
                              code: "v8-521564014178865154",
                              name: "文件上传",
                              memo: null,
                              status: "1",
                              applicationId:
                                "09f63db0646111eba70f7fae370101e5",
                              parentId: "f55612e0766711ebc1efeeb47ed3ca72",
                              type: "2",
                              icon: null,
                              origin: "",
                              url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/webportal/uploadFile?menuid=521564014178865154",
                              target: "iframe",
                              order: 1,
                              level: 5,
                              lft: 2043,
                              rgt: 2044,
                              children: [],
                            },
                          ],
                        },
                        {
                          id: "f55bb830766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-12345678910111213",
                          name: "UKEY管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/UkeyInfo/queryUkeyInfoPage?menuid=12345678910111213",
                          target: "iframe",
                          order: 13,
                          level: 4,
                          lft: 2030,
                          rgt: 2041,
                          children: [],
                        },
                        {
                          id: "f55ec570766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-22",
                          name: "多客户管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/organcode/organcodeManage?menuid=22",
                          target: "iframe",
                          order: 14,
                          level: 4,
                          lft: 2022,
                          rgt: 2029,
                          children: [],
                        },
                        {
                          id: "f561f9c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-345",
                          name: "操作员商户绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/usermerbind/querySysUserMerBind?menuid=345",
                          target: "iframe",
                          order: 15,
                          level: 4,
                          lft: 2014,
                          rgt: 2021,
                          children: [],
                        },
                        {
                          id: "f5655520766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1170",
                          name: "系统定时定义",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/scheduleTriggers/queryscheduletriggers?menuid=1170",
                          target: "iframe",
                          order: 16,
                          level: 4,
                          lft: 2002,
                          rgt: 2013,
                          children: [],
                        },
                        {
                          id: "f5686260766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-342",
                          name: "用户权限树",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysuser/sysusertree?menuid=342",
                          target: "iframe",
                          order: 17,
                          level: 4,
                          lft: 2000,
                          rgt: 2001,
                          children: [],
                        },
                        {
                          id: "f56bbdc0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-31",
                          name: "部门管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/dept/querydeptlist?menuid=31",
                          target: "iframe",
                          order: 18,
                          level: 4,
                          lft: 1990,
                          rgt: 1999,
                          children: [],
                        },
                        {
                          id: "f56e55d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-29",
                          name: "用户管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysuser/querysysuser?menuid=29",
                          target: "iframe",
                          order: 19,
                          level: 4,
                          lft: 1978,
                          rgt: 1989,
                          children: [],
                        },
                        {
                          id: "46d43cf0807711eb867bcf56cff86721",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-03-09T09:32:14.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-03-09T09:32:28.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-522596496081157644",
                          name: "设备参数转换工具",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/driveParamTran/toDriveParamTranPage?menuid=522596496081157644",
                          target: "iframe",
                          order: 19,
                          level: 4,
                          lft: 2114,
                          rgt: 2115,
                          children: [],
                        },
                        {
                          id: "f5716310766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-27",
                          name: "角色管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysrole/querysysroledefine?menuid=27",
                          target: "iframe",
                          order: 20,
                          level: 4,
                          lft: 1970,
                          rgt: 1977,
                          children: [],
                        },
                        {
                          id: "f5742230766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-25",
                          name: "系统客户端设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysclient/querysysclient?menuid=25",
                          target: "iframe",
                          order: 21,
                          level: 4,
                          lft: 1962,
                          rgt: 1969,
                          children: [],
                        },
                        {
                          id: "f57bc350766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-35",
                          name: "重置操作员密码",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysuser/openReset?menuid=35",
                          target: "iframe",
                          order: 22,
                          level: 4,
                          lft: 1960,
                          rgt: 1961,
                          children: [],
                        },
                        {
                          id: "f57ea980766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-23",
                          name: "校区代码设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysschool/querysysschooldef?menuid=23",
                          target: "iframe",
                          order: 23,
                          level: 4,
                          lft: 1950,
                          rgt: 1959,
                          children: [],
                        },
                        {
                          id: "f5818fb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-43",
                          name: "圈存站点设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/stationdef/querystationdeflist?menuid=43",
                          target: "iframe",
                          order: 24,
                          level: 4,
                          lft: 1942,
                          rgt: 1949,
                          children: [],
                        },
                        {
                          id: "f584c400766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-41",
                          name: "系统结账",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/eod/eodList?menuid=41",
                          target: "iframe",
                          order: 25,
                          level: 4,
                          lft: 1934,
                          rgt: 1937,
                          children: [],
                        },
                        {
                          id: "f5878320766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-380",
                          name: "修改授权管理员密码",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/authorizer/modifyAuthorizerPwd?menuid=380",
                          target: "iframe",
                          order: 26,
                          level: 4,
                          lft: 1932,
                          rgt: 1933,
                          children: [],
                        },
                        {
                          id: "b1929720a62f11eb109f9cece5b5e762",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-04-26T09:35:34.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-04-26T09:36:30.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-522596496089157648",
                          name: "密钥平台配置管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5303b60766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/syssecretkeyinfo/querysyssecretkeyinfo?menuid=522596496089157648",
                          target: "iframe",
                          order: 27,
                          level: 4,
                          lft: 2116,
                          rgt: 2117,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f58a6950766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:24.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-45",
                      name: "数据字典设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 8,
                      level: 3,
                      lft: 1829,
                      rgt: 1930,
                      children: [
                        {
                          id: "f58dc4b0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-912",
                          name: "小钱包设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/syspurse/querysyspursedef?menuid=912",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 1910,
                          rgt: 1915,
                          children: [],
                        },
                        {
                          id: "f590d1f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2028",
                          name: "模板管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysimportmodule/querySysImportModuleDefRun?menuid=2028",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 1924,
                          rgt: 1929,
                          children: [],
                        },
                        {
                          id: "f593b820766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2026",
                          name: "模板字段管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysimportmodule/querysysimportmodule?menuid=2026",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 1920,
                          rgt: 1923,
                          children: [],
                        },
                        {
                          id: "f59761a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1921",
                          name: "介入者身份绑定管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/positionset/IdentityBindingdef?menuid=1921",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 1902,
                          rgt: 1909,
                          children: [],
                        },
                        {
                          id: "f59a95f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2052",
                          name: "POS设备运行参数组设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/group/posRunParameters?menuid=2052",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 1890,
                          rgt: 1901,
                          children: [],
                        },
                        {
                          id: "f59d5510766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-47",
                          name: "国籍设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/country/getCountryList?menuid=47",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 1888,
                          rgt: 1889,
                          children: [],
                        },
                        {
                          id: "f5a06250766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-49",
                          name: "民族设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/nation/getNationList?menuid=49",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 1886,
                          rgt: 1887,
                          children: [],
                        },
                        {
                          id: "f5a34880766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-59",
                          name: "身份设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/positionset/querypositiondef?menuid=59",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 1878,
                          rgt: 1885,
                          children: [],
                        },
                        {
                          id: "f5a655c0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-51",
                          name: "学位设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/degree/querydegreedef?menuid=51",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 1870,
                          rgt: 1877,
                          children: [],
                        },
                        {
                          id: "f5b28ac0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-53",
                          name: "证件设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/idtype/queryidtypedef?menuid=53",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 1862,
                          rgt: 1869,
                          children: [],
                        },
                        {
                          id: "b65718d0767311ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T15:41:32.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T15:41:46.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-2039",
                          name: "模板管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "http://dk-ykt.paas.newcapec.cn",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysimportmodule/querySysImportModuleDefRun?menuid=2039",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 1938,
                          rgt: 1941,
                          children: [],
                        },
                        {
                          id: "f5b59800766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-55",
                          name: "职位设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/job/queryjobdef?menuid=55",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 1854,
                          rgt: 1861,
                          children: [],
                        },
                        {
                          id: "f5bfaa20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-57",
                          name: "押金设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/pledge/querypledgedef?menuid=57",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 1846,
                          rgt: 1853,
                          children: [],
                        },
                        {
                          id: "f5c353a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-61",
                          name: "账户类型设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/accounttype/querysysacctype?menuid=61",
                          target: "iframe",
                          order: 13,
                          level: 4,
                          lft: 1838,
                          rgt: 1845,
                          children: [],
                        },
                        {
                          id: "f5c85cb0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-63",
                          name: "卡成本设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f58a6950766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cardcost/querysyscardcost?menuid=63",
                          target: "iframe",
                          order: 14,
                          level: 4,
                          lft: 1830,
                          rgt: 1837,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:24.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-65",
                      name: "参数设置",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 9,
                      level: 3,
                      lft: 1781,
                      rgt: 1828,
                      children: [
                        {
                          id: "f5d18470766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-265",
                          name: "其他参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysohterparam/querysysohterparam?menuid=265",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 1812,
                          rgt: 1815,
                          children: [],
                        },
                        {
                          id: "f5d52df0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-10000",
                          name: "监控参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/metricsysconfig/querymetricsysconfig?menuid=10000",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 1804,
                          rgt: 1811,
                          children: [],
                        },
                        {
                          id: "f5d8fe80766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-443966971495714816",
                          name: "支付渠道设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysPayChannel/queryPaychannel?menuid=443966971495714816",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 1800,
                          rgt: 1803,
                          children: [],
                        },
                        {
                          id: "f5dd4440766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-72",
                          name: "校园码应用参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysohterparam/syscampuscodelist?menuid=72",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 1798,
                          rgt: 1799,
                          children: [],
                        },
                        {
                          id: "f5e1b110766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-916",
                          name: "网关配置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/gatewayconfigtype/gatewayconfigtypelist?menuid=916",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 1820,
                          rgt: 1827,
                          children: [],
                        },
                        {
                          id: "f5e581a0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-37",
                          name: "卡片注册",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cardchkcardid/cardregistration?menuid=37",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 1796,
                          rgt: 1797,
                          children: [],
                        },
                        {
                          id: "f5e8dd00766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-73",
                          name: "餐次设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysmealtime/querysysmealtime?menuid=73",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 1788,
                          rgt: 1795,
                          children: [],
                        },
                        {
                          id: "f5ebea40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-67",
                          name: "卡参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/cardparam/getCardParamList?menuid=67",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 1786,
                          rgt: 1787,
                          children: [],
                        },
                        {
                          id: "f5f008f0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:24.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-69",
                          name: "系统控制设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/ctrl/queryctrlList?menuid=69",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 1784,
                          rgt: 1785,
                          children: [],
                        },
                        {
                          id: "f5f33d40766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-71",
                          name: "系统参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysohterparam/queryParamList?menuid=71",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 1782,
                          rgt: 1783,
                          children: [],
                        },
                        {
                          id: "b341cdc0a62f11eb109f9cece5b5e762",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-04-26T09:35:37.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-04-26T09:36:32.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670074",
                          name: "银联优惠设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5cdb3e0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/unionpaymanage/unionpaymanage?menuid=1670074",
                          target: "iframe",
                          order: 12,
                          level: 4,
                          lft: 1818,
                          rgt: 1819,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f5f698a0766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:25.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-77",
                      name: "信息查询",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 10,
                      level: 3,
                      lft: 1771,
                      rgt: 1780,
                      children: [
                        {
                          id: "f5fa6930766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-81",
                          name: "操作流水查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5f698a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/sysselftrade/querySysSelfTrade?menuid=81",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 1774,
                          rgt: 1775,
                          children: [],
                        },
                        {
                          id: "f5ff4b30766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-79",
                          name: "日志查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f5f698a0766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/syslog/querysyslog?menuid=79",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 1772,
                          rgt: 1773,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "f603b800766711ebc1efeeb47ed3ca72",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-24T14:17:25.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-24T14:34:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-83",
                      name: "商户日常管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 11,
                      level: 3,
                      lft: 1695,
                      rgt: 1770,
                      children: [
                        {
                          id: "f6078890766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-245",
                          name: "重置商户密码",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/openResetMerPass?menuid=245",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 1768,
                          rgt: 1769,
                          children: [],
                        },
                        {
                          id: "f60b0b00766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-475553173080248320",
                          name: "商户类型设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/querymerchanttypeList?menuid=475553173080248320",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 1760,
                          rgt: 1767,
                          children: [],
                        },
                        {
                          id: "f60e8d70766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-475615472327462912",
                          name: "商户类型绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/querySysMertypebind?menuid=475615472327462912",
                          target: "iframe",
                          order: 3,
                          level: 4,
                          lft: 1752,
                          rgt: 1759,
                          children: [],
                        },
                        {
                          id: "f6132150766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-478394258173333504",
                          name: "POS类型设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/queryPostypeList?menuid=478394258173333504",
                          target: "iframe",
                          order: 4,
                          level: 4,
                          lft: 1744,
                          rgt: 1751,
                          children: [],
                        },
                        {
                          id: "f6178e20766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-478507660422025216",
                          name: "POS设备类型绑定",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/queryPostypebind?menuid=478507660422025216",
                          target: "iframe",
                          order: 5,
                          level: 4,
                          lft: 1738,
                          rgt: 1743,
                          children: [],
                        },
                        {
                          id: "f61ae980766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9002",
                          name: "绑定校区设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/bindSchoolMerchantList?menuid=9002",
                          target: "iframe",
                          order: 6,
                          level: 4,
                          lft: 1730,
                          rgt: 1737,
                          children: [],
                        },
                        {
                          id: "f61e9300766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-9001",
                          name: "校区商户参数设置",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/schoolMerchantConfList?menuid=9001",
                          target: "iframe",
                          order: 7,
                          level: 4,
                          lft: 1722,
                          rgt: 1729,
                          children: [],
                        },
                        {
                          id: "f6228aa0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-85",
                          name: "商户管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/querymerchantlist?menuid=85",
                          target: "iframe",
                          order: 8,
                          level: 4,
                          lft: 1712,
                          rgt: 1721,
                          children: [],
                        },
                        {
                          id: "f626a950766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-87",
                          name: "商户信息完善",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/queryMerchant?menuid=87",
                          target: "iframe",
                          order: 9,
                          level: 4,
                          lft: 1700,
                          rgt: 1711,
                          children: [],
                        },
                        {
                          id: "f62a52d0766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-89",
                          name: "商户流水查询",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/mselftradeselflist?menuid=89",
                          target: "iframe",
                          order: 10,
                          level: 4,
                          lft: 1698,
                          rgt: 1699,
                          children: [],
                        },
                        {
                          id: "f62dd540766711ebc1efeeb47ed3ca72",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-02-24T14:17:25.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-02-24T14:34:52.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-91",
                          name: "商户转账",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "f603b800766711ebc1efeeb47ed3ca72",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/merchant/merchantTransferList?menuid=91",
                          target: "iframe",
                          order: 11,
                          level: 4,
                          lft: 1696,
                          rgt: 1697,
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "c689bec080a411eb867bcf56cff86721",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-03-09T14:57:56.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-03-09T14:58:14.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "v8-1670065",
                      name: "多平台管理",
                      memo: null,
                      status: "1",
                      applicationId: "09f63db0646111eba70f7fae370101e5",
                      parentId: "f4c91520766711ebc1efeeb47ed3ca72",
                      type: "2",
                      icon: null,
                      origin: "",
                      url: null,
                      target: "iframe",
                      order: 12,
                      level: 3,
                      lft: 2243,
                      rgt: 2248,
                      children: [
                        {
                          id: "c697ef9080a411eb867bcf56cff86721",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-03-09T14:57:56.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-03-09T14:58:14.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670067",
                          name: "操作员绑定平台",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "c689bec080a411eb867bcf56cff86721",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/platformmanage/platformbin?menuid=1670067",
                          target: "iframe",
                          order: 1,
                          level: 4,
                          lft: 2246,
                          rgt: 2247,
                          children: [],
                        },
                        {
                          id: "c6b848d080a411eb867bcf56cff86721",
                          companyId: "1",
                          deleted: false,
                          addAccount: "smartadmin",
                          addTime: "2021-03-09T14:57:56.000+0800",
                          editAccount: "smartadmin",
                          editTime: "2021-03-09T14:58:14.000+0800",
                          deleteAccount: null,
                          deleteTime: null,
                          code: "v8-1670066",
                          name: "多平台管理",
                          memo: null,
                          status: "1",
                          applicationId: "09f63db0646111eba70f7fae370101e5",
                          parentId: "c689bec080a411eb867bcf56cff86721",
                          type: "2",
                          icon: null,
                          origin: "",
                          url: "http://dk-ykt.paas.newcapec.cn/ykt/permission/platformmanage/platformmanage?menuid=1670066",
                          target: "iframe",
                          order: 2,
                          level: 4,
                          lft: 2244,
                          rgt: 2245,
                          children: [],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              id: "1",
              companyId: null,
              deleted: false,
              addAccount: null,
              addTime: null,
              editAccount: null,
              editTime: null,
              deleteAccount: null,
              deleteTime: null,
              code: "admin-center",
              name: "云平台管理",
              memo: null,
              status: "1",
              applicationId: "1",
              parentId: "0",
              type: "2",
              icon: "el-icon-menu",
              origin: "http://admin-platform.paas.newcapec.cn",
              url: "",
              target: null,
              order: 1,
              level: 1,
              lft: 21,
              rgt: 1694,
              children: [
                {
                  id: "8656c870fa8911ebf7d481510aaf2422",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-08-11T17:50:14.000+0800",
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "customized-serv",
                  name: "健康台账",
                  memo: "",
                  status: "1",
                  applicationId: "00000",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "",
                  url: "",
                  target: "",
                  order: 100,
                  level: 2,
                  lft: 1684,
                  rgt: 1693,
                  children: [
                    {
                      id: "ab038410fa8911ebf7d481510aaf2422",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-11T17:51:15.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-08-12T17:39:06.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "customized-test",
                      name: "上报信息",
                      memo: "",
                      status: "1",
                      applicationId: "00000",
                      parentId: "8656c870fa8911ebf7d481510aaf2422",
                      type: "2",
                      icon: "",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/customized-serv/healthIndex",
                      target: "",
                      order: 0,
                      level: 3,
                      lft: 1685,
                      rgt: 1686,
                      children: [],
                    },
                    {
                      id: "e1663b80fc0d11ebf7d481510aaf2422",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-13T16:10:11.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "jqttj",
                      name: "七天统计",
                      memo: "",
                      status: "1",
                      applicationId: "00000",
                      parentId: "8656c870fa8911ebf7d481510aaf2422",
                      type: "2",
                      icon: "",
                      origin: "",
                      url: "https://datareport.paas.newcapec.cn/dataReport/jmreport/view/585692275328487424",
                      target: "iframe",
                      order: 0,
                      level: 3,
                      lft: 1689,
                      rgt: 1690,
                      children: [],
                    },
                    {
                      id: "5dca8bd0fb5111ebf7d481510aaf2422",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-12T17:40:45.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-08-13T16:08:12.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "report",
                      name: "报表设计",
                      memo: "",
                      status: "1",
                      applicationId: "00000",
                      parentId: "8656c870fa8911ebf7d481510aaf2422",
                      type: "2",
                      icon: "",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/customized-serv/report",
                      target: "",
                      order: 2,
                      level: 3,
                      lft: 1687,
                      rgt: 1688,
                      children: [],
                    },
                    {
                      id: "96a50170fc0e11ebf7d481510aaf2422",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-13T16:15:15.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "sbtj",
                      name: "上报统计",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8656c870fa8911ebf7d481510aaf2422",
                      type: "2",
                      icon: "",
                      origin: "",
                      url: "https://datareport.paas.newcapec.cn/dataReport/jmreport/view/584541926211260416",
                      target: "iframe",
                      order: 0,
                      level: 3,
                      lft: 1691,
                      rgt: 1692,
                      children: [],
                    },
                  ],
                },
                {
                  id: "c86842b0c35311eb602305277b20c381",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-06-02T11:36:58.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2021-06-02T11:41:02.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "data-screen",
                  name: "数据大屏",
                  memo: "",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "su-icon-zhutifangan",
                  origin: "http://data-screen.paas.newcapec.cn",
                  url: "/",
                  target: "iframe",
                  order: 0,
                  level: 2,
                  lft: 1680,
                  rgt: 1683,
                  children: [
                    {
                      id: "c0bca5f0c35411eb602305277b20c381",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-06-02T11:43:54.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-06-02T11:44:13.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "data-screen-index",
                      name: "数据大屏",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "c86842b0c35311eb602305277b20c381",
                      type: "2",
                      icon: "su-icon-menhu",
                      origin: "http://data-screen.paas.newcapec.cn",
                      url: "http://data-screen.paas.newcapec.cn",
                      target: "self",
                      order: 0,
                      level: 3,
                      lft: 1681,
                      rgt: 1682,
                      children: [],
                    },
                  ],
                },
                {
                  id: "8faabed0eb5911ead32bc04a89a1c092",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2020-08-31T15:14:08.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2020-12-03T10:55:09.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "portal-admin",
                  name: "融合门户",
                  memo: "",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "",
                  url: "",
                  target: null,
                  order: 0,
                  level: 2,
                  lft: 170,
                  rgt: 189,
                  children: [
                    {
                      id: "d1b90980645311eba70f7fae370101e5",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-01T14:07:53.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-01T14:17:00.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "appBale",
                      name: "App打包",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-pm-file-analyze",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/appBaleAdmin",
                      target: "self",
                      order: 0,
                      level: 3,
                      lft: 179,
                      rgt: 180,
                      children: [],
                    },
                    {
                      id: "61ca42a0016611ec0f1acf84ccb857fb",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-20T11:26:18.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-08-20T11:34:35.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "cardTemplate",
                      name: "卡片模版管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-chongxintijiao",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/cardTemplate",
                      target: "self",
                      order: 0,
                      level: 3,
                      lft: 181,
                      rgt: 182,
                      children: [],
                    },
                    {
                      id: "a625f480016611ec0f1acf84ccb857fb",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-20T11:28:13.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-08-20T11:35:22.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "cardLibrary",
                      name: "卡片库管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-tongxunxinxi",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/cardLibrary",
                      target: "",
                      order: 1,
                      level: 3,
                      lft: 183,
                      rgt: 184,
                      children: [],
                    },
                    {
                      id: "405f4c40eb5b11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:26:14.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-18T12:55:31.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "system-admin",
                      name: "PC端设置",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-baoxiu",
                      origin: "",
                      url: "/portal-admin/sysAd",
                      target: null,
                      order: 5,
                      level: 3,
                      lft: 177,
                      rgt: 178,
                      children: [],
                    },
                    {
                      id: "60128840eb5b11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:27:07.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:24:12.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "themeAdmin",
                      name: "PC主题管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-neirongguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/themeAdmin",
                      target: null,
                      order: 5,
                      level: 3,
                      lft: 175,
                      rgt: 176,
                      children: [],
                    },
                    {
                      id: "d6820d20eb5b11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:30:26.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:23:55.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "VersionManagement",
                      name: "版本升级管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-guanliduan",
                      origin: "",
                      url: "/portal-admin/VersionManagement",
                      target: null,
                      order: 8,
                      level: 3,
                      lft: 171,
                      rgt: 172,
                      children: [],
                    },
                    {
                      id: "73d6b510061a11ec0f1acf84ccb857fb",
                      companyId: "1",
                      deleted: false,
                      addAccount: "20201113",
                      addTime: "2021-08-26T11:05:22.000+0800",
                      editAccount: "20201113",
                      editTime: "2021-08-26T11:07:17.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "analysis",
                      name: "统计分析",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-chongxintijiao",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/analysis",
                      target: "",
                      order: 9,
                      level: 3,
                      lft: 185,
                      rgt: 186,
                      children: [],
                    },
                    {
                      id: "fad3d1a00c9c11ece85faba45cf08dcd",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-09-03T17:54:50.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "appAnalysis",
                      name: "app统计分析",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-bumenqunzu-01",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/mobileAnalysis",
                      target: "",
                      order: 9,
                      level: 3,
                      lft: 187,
                      rgt: 188,
                      children: [],
                    },
                    {
                      id: "affa08f01f3c11eb39a39bf283d87714",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-05T15:58:28.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-05T16:00:26.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "mobileSystemAdmin",
                      name: "移动端设置",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "8faabed0eb5911ead32bc04a89a1c092",
                      type: "2",
                      icon: "su-icon-dailidaiban",
                      origin: "",
                      url: "/portal-admin/mobileSystemAdmin",
                      target: null,
                      order: 9,
                      level: 3,
                      lft: 173,
                      rgt: 174,
                      children: [],
                    },
                  ],
                },
                {
                  id: "193b2790351311ebc9b242ef3eda0a9e",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2020-12-03T10:56:11.000+0800",
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "serverAdmin",
                  name: "服务管理",
                  memo: "",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "",
                  url: "",
                  target: null,
                  order: 1,
                  level: 2,
                  lft: 206,
                  rgt: 211,
                  children: [
                    {
                      id: "9ff71290443f11eb3c2cb8807d2a4a7f",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-12-22T18:22:42.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-28T17:05:55.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "ApplicationService",
                      name: "应用服务管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "193b2790351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-xiaoxileibie",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/ApplicationService",
                      target: null,
                      order: 2,
                      level: 3,
                      lft: 209,
                      rgt: 210,
                      children: [],
                    },
                    {
                      id: "94c65a80eb5b11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:28:36.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:24:03.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "tagboard-admin",
                      name: "标签管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "193b2790351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-xiaoxiwangguan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/tagadmin",
                      target: null,
                      order: 7,
                      level: 3,
                      lft: 207,
                      rgt: 208,
                      children: [],
                    },
                  ],
                },
                {
                  id: "3264f520351311ebc9b242ef3eda0a9e",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2020-12-03T10:56:53.000+0800",
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "cmsAdmin",
                  name: "CMS管理",
                  memo: "",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "",
                  url: "",
                  target: null,
                  order: 2,
                  level: 2,
                  lft: 212,
                  rgt: 231,
                  children: [
                    {
                      id: "f18148e0eb5911ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:16:52.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:23:39.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "application",
                      name: "栏目管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-yifasong",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/application/Column",
                      target: null,
                      order: 0,
                      level: 3,
                      lft: 213,
                      rgt: 214,
                      children: [],
                    },
                    {
                      id: "14546280eb5a11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:17:51.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:24:33.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "add-Column",
                      name: "添加栏目",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-biaoqianfenleiguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/application/addColumn",
                      target: null,
                      order: 2,
                      level: 3,
                      lft: 215,
                      rgt: 216,
                      children: [],
                    },
                    {
                      id: "0269a250eb5b11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:24:30.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:24:41.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "content",
                      name: "内容管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-xiaoxileibie",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/application/content",
                      target: null,
                      order: 2,
                      level: 3,
                      lft: 219,
                      rgt: 220,
                      children: [],
                    },
                    {
                      id: "dfceafb0eb5a11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:23:32.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:23:47.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "add-content",
                      name: "添加内容",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-addsort",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/application/addContent",
                      target: null,
                      order: 3,
                      level: 3,
                      lft: 217,
                      rgt: 218,
                      children: [],
                    },
                    {
                      id: "395b7320eb5a11ead32bc04a89a1c092",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-08-31T15:18:53.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-08-31T17:24:23.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "slideManage",
                      name: "轮播图管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-renwujiankong",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/portal-admin/slideShow",
                      target: null,
                      order: 4,
                      level: 3,
                      lft: 227,
                      rgt: 228,
                      children: [],
                    },
                    {
                      id: "e7025f50a74011eb109f9cece5b5e762",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-04-27T18:11:16.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-04-27T18:12:58.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "userQuery",
                      name: "人员查询列表",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-account-information",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-query/userQuery",
                      target: "self",
                      order: 9,
                      level: 3,
                      lft: 229,
                      rgt: 230,
                      children: [],
                    },
                    {
                      id: "be3e04602a1411eb66867a5ca4d1df71",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-19T11:10:14.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-19T11:11:00.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "addColumnv2",
                      name: "添加栏目v2",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-zhuye",
                      origin: "",
                      url: "/portal-admin/addColumnv2",
                      target: null,
                      order: 14,
                      level: 3,
                      lft: 225,
                      rgt: 226,
                      children: [],
                    },
                    {
                      id: "08129f102a1511eb66867a5ca4d1df71",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-19T11:12:18.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-19T11:14:41.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "Columnv2",
                      name: "栏目管理V2",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-qxczsj",
                      origin: "",
                      url: "/portal-admin/Columnv2",
                      target: null,
                      order: 15,
                      level: 3,
                      lft: 223,
                      rgt: 224,
                      children: [],
                    },
                    {
                      id: "398a0b002a1511eb66867a5ca4d1df71",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-19T11:13:41.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-12-03T11:00:31.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "contentv2",
                      name: "内容管理v2",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3264f520351311ebc9b242ef3eda0a9e",
                      type: "2",
                      icon: "su-icon-addsort",
                      origin: "",
                      url: "/portal-admin/contentv2",
                      target: null,
                      order: 17,
                      level: 3,
                      lft: 221,
                      rgt: 222,
                      children: [],
                    },
                  ],
                },
                {
                  id: "c0b57fe0433511eb3c2cb8807d2a4a7f",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2020-12-21T10:39:31.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2020-12-21T10:41:53.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "adress-book",
                  name: "通讯录",
                  memo: "",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "su-icon-bumenqunzu-01",
                  origin: "http://admin-platform.paas.newcapec.cn",
                  url: "/",
                  target: null,
                  order: 8088,
                  level: 2,
                  lft: 232,
                  rgt: 239,
                  children: [
                    {
                      id: "5854cea0433611eb3c2cb8807d2a4a7f",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-12-21T10:43:45.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "departmentGroupManager",
                      name: "部门群组管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "c0b57fe0433511eb3c2cb8807d2a4a7f",
                      type: "2",
                      icon: "su-icon-jiedian",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/address-book/departmentGroupManager",
                      target: null,
                      order: 8089,
                      level: 3,
                      lft: 233,
                      rgt: 234,
                      children: [],
                    },
                    {
                      id: "8ea2f320433a11eb3c2cb8807d2a4a7f",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-12-21T11:13:55.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-12-21T11:15:54.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "commonGroupManager",
                      name: "普通群组管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "c0b57fe0433511eb3c2cb8807d2a4a7f",
                      type: "2",
                      icon: "su-icon-putongqunzu",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/address-book/commonGroupManager",
                      target: null,
                      order: 8101,
                      level: 3,
                      lft: 237,
                      rgt: 238,
                      children: [],
                    },
                    {
                      id: "c6ddf050433a11eb3c2cb8807d2a4a7f",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-12-21T11:15:29.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "addressBookSetting",
                      name: "设置",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "c0b57fe0433511eb3c2cb8807d2a4a7f",
                      type: "2",
                      icon: "su-icon-setting",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/address-book/addressBookSetting",
                      target: null,
                      order: 8102,
                      level: 3,
                      lft: 235,
                      rgt: 236,
                      children: [],
                    },
                  ],
                },
                {
                  id: "20000",
                  companyId: null,
                  deleted: false,
                  addAccount: null,
                  addTime: null,
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "cas-server",
                  name: "认证管理",
                  memo: null,
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "http://admin-platform.paas.newcapec.cn",
                  url: "/",
                  target: null,
                  order: 20000,
                  level: 1,
                  lft: 22,
                  rgt: 55,
                  children: [
                    {
                      id: "20100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "loginConfig",
                      name: "登录方式配置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-denglupeizhi",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/loginConfig",
                      target: null,
                      order: 20100,
                      level: 2,
                      lft: 23,
                      rgt: 24,
                      children: [],
                    },
                    {
                      id: "20200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "safeLoginConfig",
                      name: "账号安全配置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-config-security",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/safeLoginConfig",
                      target: null,
                      order: 20200,
                      level: 2,
                      lft: 25,
                      rgt: 28,
                      children: [],
                    },
                    {
                      id: "20300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "accountActivationConfiguration",
                      name: "账号激活配置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-bulb",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/accountActivationConfiguration",
                      target: null,
                      order: 20300,
                      level: 2,
                      lft: 29,
                      rgt: 30,
                      children: [],
                    },
                    {
                      id: "20400",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "safeConfig",
                      name: "安全策略配置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-celuepeizhi",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/safeConfig",
                      target: null,
                      order: 20400,
                      level: 2,
                      lft: 31,
                      rgt: 32,
                      children: [],
                    },
                    {
                      id: "20500",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "passwordConfig",
                      name: "密码策略配置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-mimacelue",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/passwordConfig",
                      target: null,
                      order: 20500,
                      level: 2,
                      lft: 33,
                      rgt: 34,
                      children: [],
                    },
                    {
                      id: "20600",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: "smartadmin",
                      editTime: "2020-12-17T18:57:57.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "serverManagement",
                      name: "认证对接配置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "el-icon-service",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/serverManagement",
                      target: null,
                      order: 20600,
                      level: 2,
                      lft: 35,
                      rgt: 36,
                      children: [],
                    },
                    {
                      id: "21100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: "smartadmin",
                      editTime: "2021-08-16T15:18:57.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "analyze",
                      name: "认证统计分析",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-renzhengtongjifenxi",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/analyze",
                      target: null,
                      order: 21100,
                      level: 2,
                      lft: 37,
                      rgt: 38,
                      children: [],
                    },
                    {
                      id: "1b04f6b0232e11eb39a39bf283d87714",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-10T16:24:09.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-10T16:24:33.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "dengluyemianpeizhi",
                      name: "登录页面配置",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-tongxunxinxi",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/loginPageConfig",
                      target: null,
                      order: 21101,
                      level: 2,
                      lft: 39,
                      rgt: 40,
                      children: [],
                    },
                    {
                      id: "244bcbe04f2a11ebe014eb5cac07a026",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-05T15:46:38.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-05T15:47:11.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "lhdlpz",
                      name: "联合登录配置",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-test",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/linkLoginConfig",
                      target: null,
                      order: 22100,
                      level: 2,
                      lft: 41,
                      rgt: 42,
                      children: [],
                    },
                    {
                      id: "00ddbf20fe6011eb0f1acf84ccb857fb",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-16T15:03:05.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-08-16T15:03:54.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "analyzeManage",
                      name: "认证统计分析",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-zhutifangan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/analyzeManage",
                      target: "self",
                      order: 23000,
                      level: 2,
                      lft: 49,
                      rgt: 50,
                      children: [],
                    },
                    {
                      id: "44ba7b60823d11eb867bcf56cff86721",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-03-11T15:42:02.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "infoPerfectConfig",
                      name: "信息完善配置",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-chongxintijiao",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/infoPerfectConfig",
                      target: "",
                      order: 94503,
                      level: 2,
                      lft: 47,
                      rgt: 48,
                      children: [],
                    },
                    {
                      id: "913fe4e0660711eba70f7fae370101e5",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-03T18:07:05.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-03T18:10:10.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "casConfig",
                      name: "认证对接配置(uniauth)",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-collection-1",
                      origin: "",
                      url: "/cas-server/casConfig",
                      target: "",
                      order: 999999,
                      level: 2,
                      lft: 45,
                      rgt: 46,
                      children: [],
                    },
                    {
                      id: "c4d9d4600b9711ece85faba45cf08dcd",
                      companyId: "1",
                      deleted: false,
                      addAccount: "defaultOperator",
                      addTime: "2021-09-02T10:45:01.000+0800",
                      editAccount: "defaultOperator",
                      editTime: "2021-09-02T10:48:39.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "logManagement",
                      name: "日志管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-liuchengguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/logManagement",
                      target: "",
                      order: 999999,
                      level: 2,
                      lft: 53,
                      rgt: 54,
                      children: [],
                    },
                    {
                      id: "71e0c120597611eba00bb6a616f291c4",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-18T18:18:02.000+0800",
                      editAccount: "defaultOperator",
                      editTime: "2021-09-02T10:46:01.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "suodingguanli",
                      name: "锁定管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-shouquanjiguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/lockManagement",
                      target: "",
                      order: 999999,
                      level: 2,
                      lft: 43,
                      rgt: 44,
                      children: [],
                    },
                    {
                      id: "40bbfca00a3c11ec0f1acf84ccb857fb",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-08-31T17:17:24.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-08-31T17:21:02.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "twoFactorAuth",
                      name: "双因子认证",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "20000",
                      type: "2",
                      icon: "su-icon-jiaoseguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/cas-server/twoFactorAuth",
                      target: "",
                      order: 999999,
                      level: 2,
                      lft: 51,
                      rgt: 52,
                      children: [],
                    },
                  ],
                },
                {
                  id: "30000",
                  companyId: null,
                  deleted: false,
                  addAccount: null,
                  addTime: null,
                  editAccount: "smartadmin",
                  editTime: "2021-05-08T10:44:21.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "user-server",
                  name: "用户管理",
                  memo: null,
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "http://admin-platform.paas.newcapec.cn/",
                  url: "/",
                  target: null,
                  order: 30000,
                  level: 1,
                  lft: 56,
                  rgt: 77,
                  children: [
                    {
                      id: "30100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "dictionary",
                      name: "字典管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-zidian",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/dictionary",
                      target: null,
                      order: 30100,
                      level: 2,
                      lft: 57,
                      rgt: 58,
                      children: [],
                    },
                    {
                      id: "30200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: "smartadmin",
                      editTime: "2021-05-08T10:44:42.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "identity",
                      name: "身份管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-shenfen",
                      origin: "",
                      url: "/user-server/identity",
                      target: null,
                      order: 30200,
                      level: 2,
                      lft: 59,
                      rgt: 60,
                      children: [],
                    },
                    {
                      id: "30300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "mechanism",
                      name: "组织机构管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-department",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/mechanism",
                      target: null,
                      order: 30300,
                      level: 2,
                      lft: 61,
                      rgt: 62,
                      children: [],
                    },
                    {
                      id: "30400",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "person",
                      name: "人员管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-people",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/person",
                      target: null,
                      order: 30400,
                      level: 2,
                      lft: 63,
                      rgt: 64,
                      children: [],
                    },
                    {
                      id: "30500",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "label",
                      name: "标签管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-biaoqian",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/label",
                      target: null,
                      order: 30500,
                      level: 2,
                      lft: 65,
                      rgt: 66,
                      children: [],
                    },
                    {
                      id: "30600",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "simpleUserGroupManage",
                      name: "普通用户组管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-portrait",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/simpleUserGroupManage",
                      target: null,
                      order: 30600,
                      level: 2,
                      lft: 67,
                      rgt: 68,
                      children: [],
                    },
                    {
                      id: "30700",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "postUserGroupManage",
                      name: "岗位用户组管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-personnel",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/postUserGroupManage",
                      target: null,
                      order: 30700,
                      level: 2,
                      lft: 69,
                      rgt: 70,
                      children: [],
                    },
                    {
                      id: "30750",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "userScope",
                      name: "用户规则",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "el-icon-guide",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/userScope",
                      target: null,
                      order: 30750,
                      level: 2,
                      lft: 71,
                      rgt: 72,
                      children: [],
                    },
                    {
                      id: "30800",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "assignation",
                      name: "人员分配",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-tihuanbanliren",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/assignation",
                      target: null,
                      order: 30800,
                      level: 2,
                      lft: 73,
                      rgt: 74,
                      children: [],
                    },
                    {
                      id: "31000",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "activateAccount",
                      name: "账号激活审核",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "30000",
                      type: "2",
                      icon: "su-icon-yonghushouquan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-server/activateAccount",
                      target: null,
                      order: 31000,
                      level: 2,
                      lft: 75,
                      rgt: 76,
                      children: [],
                    },
                  ],
                },
                {
                  id: "40000",
                  companyId: null,
                  deleted: false,
                  addAccount: null,
                  addTime: null,
                  editAccount: "smartadmin",
                  editTime: "2021-05-07T18:22:11.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "authorization-server",
                  name: "授权管理",
                  memo: null,
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "",
                  url: "",
                  target: null,
                  order: 40000,
                  level: 1,
                  lft: 78,
                  rgt: 105,
                  children: [
                    {
                      id: "40100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "applicationRole",
                      name: "应用角色管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-yingyongjuese",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/applicationRole",
                      target: null,
                      order: 40100,
                      level: 2,
                      lft: 79,
                      rgt: 80,
                      children: [],
                    },
                    {
                      id: "40200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "authorizationRoleComponent",
                      name: "角色组管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-juesezu",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/authorizationRoleComponent",
                      target: null,
                      order: 40200,
                      level: 2,
                      lft: 81,
                      rgt: 82,
                      children: [],
                    },
                    {
                      id: "40300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "userAuthManagePeople",
                      name: "用户授权管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-yonghushouquan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/userAuthManagePeople",
                      target: null,
                      order: 40300,
                      level: 2,
                      lft: 83,
                      rgt: 84,
                      children: [],
                    },
                    {
                      id: "40400",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "roleAuthManagement",
                      name: "用户规则授权管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-yonghuguize",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/roleAuthManagement",
                      target: null,
                      order: 40400,
                      level: 2,
                      lft: 85,
                      rgt: 86,
                      children: [],
                    },
                    {
                      id: "40500",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "userGroupAuth",
                      name: "用户组授权管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-yonghuguize",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/userGroupAuth",
                      target: null,
                      order: 40500,
                      level: 2,
                      lft: 87,
                      rgt: 88,
                      children: [],
                    },
                    {
                      id: "40900",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "authorizationAndManagement",
                      name: "分级授权管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-shouquanjiguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/authorizationAndManagement",
                      target: null,
                      order: 40900,
                      level: 2,
                      lft: 89,
                      rgt: 90,
                      children: [],
                    },
                    {
                      id: "41100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "accountAuthorizationAudit",
                      name: "账号授权审计",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-zhsqsj",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/accountAuthorizationAudit",
                      target: null,
                      order: 41100,
                      level: 2,
                      lft: 91,
                      rgt: 92,
                      children: [],
                    },
                    {
                      id: "41200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "userAudit",
                      name: "用户规则权限审计",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-yhgzqxsj",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/userAudit",
                      target: null,
                      order: 41200,
                      level: 2,
                      lft: 93,
                      rgt: 94,
                      children: [],
                    },
                    {
                      id: "41300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: "smartadmin",
                      editTime: "2020-12-08T11:19:43.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "rolePermissionAudit",
                      name: "角色授权审计",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-jszsqsj",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/rolePermissionAudits",
                      target: null,
                      order: 41300,
                      level: 2,
                      lft: 95,
                      rgt: 96,
                      children: [],
                    },
                    {
                      id: "5d227e90824811eb867bcf56cff86721",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-03-11T17:01:28.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-03-11T17:01:52.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "02010202",
                      name: "角色组授权审计",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-zujianmoban",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/roleGroupPermissionAudit",
                      target: "",
                      order: 41302,
                      level: 2,
                      lft: 103,
                      rgt: 104,
                      children: [],
                    },
                    {
                      id: "41400",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "authOperationsAudit",
                      name: "权限操作审计",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-qxczsj",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/authOperationsAudit",
                      target: null,
                      order: 41400,
                      level: 2,
                      lft: 97,
                      rgt: 98,
                      children: [],
                    },
                    {
                      id: "41500",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "authStatisticalMonitor",
                      name: "授权统计监控",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-sqtjjk",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/authStatisticalMonitor",
                      target: null,
                      order: 41500,
                      level: 2,
                      lft: 99,
                      rgt: 100,
                      children: [],
                    },
                    {
                      id: "b8332da04f2811ebe014eb5cac07a026",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-05T15:36:27.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-05T15:41:02.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "sqdjpz",
                      name: "授权对接应用",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "40000",
                      type: "2",
                      icon: "su-icon-setting",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/auth-server/applicationAuth",
                      target: null,
                      order: 42500,
                      level: 2,
                      lft: 101,
                      rgt: 102,
                      children: [],
                    },
                  ],
                },
                {
                  id: "50000",
                  companyId: null,
                  deleted: false,
                  addAccount: null,
                  addTime: null,
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "formflow-manager",
                  name: "流程管理",
                  memo: null,
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "http://admin-platform.paas.newcapec.cn",
                  url: "/",
                  target: null,
                  order: 50000,
                  level: 1,
                  lft: 106,
                  rgt: 121,
                  children: [
                    {
                      id: "50100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "formflow",
                      name: "流程表单",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-liuchengbiaodan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow",
                      target: null,
                      order: 50100,
                      level: 2,
                      lft: 107,
                      rgt: 108,
                      children: [],
                    },
                    {
                      id: "50200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "workbench",
                      name: "工作台",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-gongzuotai",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow/workbench",
                      target: null,
                      order: 50200,
                      level: 2,
                      lft: 109,
                      rgt: 110,
                      children: [],
                    },
                    {
                      id: "50300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "instanceManage",
                      name: "实例管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-shiliguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow/instanceManage",
                      target: null,
                      order: 50300,
                      level: 2,
                      lft: 111,
                      rgt: 112,
                      children: [],
                    },
                    {
                      id: "120a7e00614411eba70f7fae370101e5",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-28T16:37:35.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "stampManage",
                      name: "签章管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-collection-1",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow/stamp",
                      target: "",
                      order: 50400,
                      level: 2,
                      lft: 113,
                      rgt: 114,
                      children: [],
                    },
                    {
                      id: "89b9e7c0a8d311eb109f9cece5b5e762",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-04-29T18:13:27.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-04-29T18:16:06.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "ttcManage",
                      name: "事务管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-calendar-1",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow/ttc",
                      target: "self",
                      order: 50500,
                      level: 2,
                      lft: 115,
                      rgt: 116,
                      children: [],
                    },
                    {
                      id: "c4235500bdcc11eb602305277b20c381",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-05-26T10:47:53.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "urgedManage",
                      name: "督办管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-pm-notice",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow/urgedManage",
                      target: "self",
                      order: 50600,
                      level: 2,
                      lft: 117,
                      rgt: 118,
                      children: [],
                    },
                    {
                      id: "c8b88920bebf11eb602305277b20c381",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-05-27T15:47:28.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "recycleManage",
                      name: "回收站管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "50000",
                      type: "2",
                      icon: "su-icon-huishouzhan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/formflow/recycle",
                      target: "self",
                      order: 50700,
                      level: 2,
                      lft: 119,
                      rgt: 120,
                      children: [],
                    },
                  ],
                },
                {
                  id: "825dea805c8911eba00bb6a616f291c4",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-01-22T16:12:03.000+0800",
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "data-filling",
                  name: "数据填报",
                  memo: "数据填报",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "su-icon-taocanguanli",
                  origin: "http://admin-platform.paas.newcapec.cn",
                  url: "",
                  target: "",
                  order: 50101,
                  level: 2,
                  lft: 240,
                  rgt: 247,
                  children: [
                    {
                      id: "0b0fd0005c8a11eba00bb6a616f291c4",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-22T16:15:53.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-22T16:25:35.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "home",
                      name: "首页",
                      memo: "首页",
                      status: "1",
                      applicationId: "1",
                      parentId: "825dea805c8911eba00bb6a616f291c4",
                      type: "2",
                      icon: "su-icon-menhu",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/data-filling",
                      target: "",
                      order: 0,
                      level: 3,
                      lft: 241,
                      rgt: 242,
                      children: [],
                    },
                    {
                      id: "49532f505c8b11eba00bb6a616f291c4",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-22T16:24:47.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-22T19:21:28.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "preTask",
                      name: "申请任务",
                      memo: "申请任务",
                      status: "1",
                      applicationId: "1",
                      parentId: "825dea805c8911eba00bb6a616f291c4",
                      type: "2",
                      icon: "su-icon-biaoqian",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/data-filling/dataReport/pre",
                      target: "",
                      order: 0,
                      level: 3,
                      lft: 243,
                      rgt: 244,
                      children: [],
                    },
                    {
                      id: "8b631c705c8b11eba00bb6a616f291c4",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-22T16:26:37.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-22T19:21:02.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "formalTask",
                      name: "正式任务",
                      memo: "正式任务",
                      status: "1",
                      applicationId: "1",
                      parentId: "825dea805c8911eba00bb6a616f291c4",
                      type: "2",
                      icon: "su-icon-jiedian",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/data-filling/dataReport/formal",
                      target: "",
                      order: 1,
                      level: 3,
                      lft: 245,
                      rgt: 246,
                      children: [],
                    },
                  ],
                },
                {
                  id: "80000",
                  companyId: null,
                  deleted: false,
                  addAccount: null,
                  addTime: null,
                  editAccount: "smartadmin",
                  editTime: "2020-12-18T17:24:20.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "message-backstage",
                  name: "消息服务",
                  memo: null,
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "http://admin-platform.paas.newcapec.cn",
                  url: "/",
                  target: null,
                  order: 80000,
                  level: 1,
                  lft: 142,
                  rgt: 163,
                  children: [
                    {
                      id: "80100",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: "smartadmin",
                      editTime: "2021-03-22T17:48:58.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-getway",
                      name: "消息网关管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-xiaoxiwangguan",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgGateWay",
                      target: null,
                      order: 80100,
                      level: 2,
                      lft: 143,
                      rgt: 144,
                      children: [],
                    },
                    {
                      id: "03c964c08c4e11ebb31fbf2045c00177",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-03-24T11:07:06.000+0800",
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "SMS-credits-manage",
                      name: "短信额度管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-security",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/SMSCreditsManage",
                      target: "",
                      order: 80150,
                      level: 2,
                      lft: 161,
                      rgt: 162,
                      children: [],
                    },
                    {
                      id: "80200",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-template",
                      name: "短信模板管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-mobanguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/SMSTemplateManage",
                      target: null,
                      order: 80200,
                      level: 2,
                      lft: 145,
                      rgt: 146,
                      children: [],
                    },
                    {
                      id: "80300",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-type",
                      name: "消息类别管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-xiaoxileibie",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgTypes",
                      target: null,
                      order: 80300,
                      level: 2,
                      lft: 147,
                      rgt: 148,
                      children: [],
                    },
                    {
                      id: "80400",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-task",
                      name: "消息任务监控",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-renwujiankong",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgTaskMonitor",
                      target: null,
                      order: 80400,
                      level: 2,
                      lft: 149,
                      rgt: 150,
                      children: [],
                    },
                    {
                      id: "80500",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-log",
                      name: "消息日志审计",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-details",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgLogAudit",
                      target: null,
                      order: 80500,
                      level: 2,
                      lft: 151,
                      rgt: 152,
                      children: [],
                    },
                    {
                      id: "c5d447405ebf11eba70f7fae370101e5",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-01-25T11:45:32.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-01-25T11:46:49.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "msgReceiptConfig",
                      name: "消息回执管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-pm-CD",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgReceiptConfig",
                      target: "self",
                      order: 80550,
                      level: 2,
                      lft: 159,
                      rgt: 160,
                      children: [],
                    },
                    {
                      id: "80600",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-app",
                      name: "应用管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-sort",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgSoftManage",
                      target: null,
                      order: 80600,
                      level: 2,
                      lft: 153,
                      rgt: 154,
                      children: [],
                    },
                    {
                      id: "80700",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-words",
                      name: "敏感词管理",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-lock-w",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/SensitiveWords",
                      target: null,
                      order: 80700,
                      level: 2,
                      lft: 155,
                      rgt: 156,
                      children: [],
                    },
                    {
                      id: "80800",
                      companyId: null,
                      deleted: false,
                      addAccount: null,
                      addTime: null,
                      editAccount: null,
                      editTime: null,
                      deleteAccount: null,
                      deleteTime: null,
                      code: "message-setting",
                      name: "设置",
                      memo: null,
                      status: "1",
                      applicationId: "1",
                      parentId: "80000",
                      type: "2",
                      icon: "su-icon-print",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/message-backstage/msgSendCondition",
                      target: null,
                      order: 80800,
                      level: 2,
                      lft: 157,
                      rgt: 158,
                      children: [],
                    },
                  ],
                },
                {
                  id: "90000",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2020-11-25T11:21:26.000+0800",
                  editAccount: "smartadmin",
                  editTime: "2020-11-25T11:23:05.000+0800",
                  deleteAccount: null,
                  deleteTime: null,
                  code: "developer-center",
                  name: "开放平台",
                  memo: "",
                  status: "1",
                  applicationId: "1",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "http://admin-platform.paas.newcapec.cn",
                  url: "/",
                  target: null,
                  order: 90000,
                  level: 2,
                  lft: 190,
                  rgt: 205,
                  children: [
                    {
                      id: "90100",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:21:26.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T11:23:18.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "developerAccount",
                      name: "开发者账号管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-yingyongjuese",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/developerAccount",
                      target: null,
                      order: 90100,
                      level: 3,
                      lft: 191,
                      rgt: 192,
                      children: [],
                    },
                    {
                      id: "90200",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:34:42.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T13:34:02.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "businessManage",
                      name: "业务管理员账号管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-fuwupingjiaguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/businessManage",
                      target: null,
                      order: 90200,
                      level: 3,
                      lft: 203,
                      rgt: 204,
                      children: [],
                    },
                    {
                      id: "90300",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:34:42.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T13:35:46.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "scopeManage",
                      name: "Scope审核员账号管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-daifasong",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/scopeManage",
                      target: null,
                      order: 90300,
                      level: 3,
                      lft: 201,
                      rgt: 202,
                      children: [],
                    },
                    {
                      id: "90400",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:34:43.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T13:34:37.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "applicationManage",
                      name: "应用服务管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-calendar-1",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/applicationManage",
                      target: null,
                      order: 90400,
                      level: 3,
                      lft: 199,
                      rgt: 200,
                      children: [],
                    },
                    {
                      id: "90500",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:34:43.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T13:35:00.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "basicAbilityManagement",
                      name: "基础能力管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-neirongguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/basicAbilityManagement",
                      target: null,
                      order: 90500,
                      level: 3,
                      lft: 197,
                      rgt: 198,
                      children: [],
                    },
                    {
                      id: "90600",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:34:43.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T13:35:26.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "businessDomainManage",
                      name: "业务域管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-fuwupingjiaguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/businessDomainManage",
                      target: null,
                      order: 90600,
                      level: 3,
                      lft: 195,
                      rgt: 196,
                      children: [],
                    },
                    {
                      id: "90700",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2020-11-25T11:34:43.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2020-11-25T13:35:58.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "auditManagement",
                      name: "审核管理",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "90000",
                      type: "2",
                      icon: "su-icon-biaoqian",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/developer-center/auditManagement",
                      target: null,
                      order: 90700,
                      level: 3,
                      lft: 193,
                      rgt: 194,
                      children: [],
                    },
                  ],
                },
                {
                  id: "3f6b326065e811eba70f7fae370101e5",
                  companyId: "1",
                  deleted: false,
                  addAccount: "smartadmin",
                  addTime: "2021-02-03T14:22:54.000+0800",
                  editAccount: null,
                  editTime: null,
                  deleteAccount: null,
                  deleteTime: null,
                  code: "iframe-test",
                  name: "iframe测试",
                  memo: "",
                  status: "1",
                  applicationId: "6ad20e002fb111ebfc7908c6df398873",
                  parentId: "1",
                  type: "2",
                  icon: "",
                  origin: "",
                  url: "",
                  target: "",
                  order: 0,
                  level: 2,
                  lft: 248,
                  rgt: 259,
                  children: [
                    {
                      id: "a84a936075a711eb7a3a8f54baa06f90",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-23T15:20:51.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-27T16:00:04.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "iframe-test-test",
                      name: "element组件",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3f6b326065e811eba70f7fae370101e5",
                      type: "2",
                      icon: "su-icon-daifasong",
                      origin: "http://admin-layout.paas.newcapec.cn",
                      url: "https://element.eleme.io/#/zh-CN/component/installation",
                      target: "iframe",
                      order: 3,
                      level: 3,
                      lft: 251,
                      rgt: 252,
                      children: [],
                    },
                    {
                      id: "77e9b050b6bd11eb602305277b20c381",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-05-17T11:10:44.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-05-17T11:24:42.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "cmsColumn",
                      name: "cms菜单管理-二开",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3f6b326065e811eba70f7fae370101e5",
                      type: "2",
                      icon: "su-icon-lanmuguanli",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-query/cmsColumn",
                      target: "self",
                      order: 11,
                      level: 3,
                      lft: 255,
                      rgt: 256,
                      children: [],
                    },
                    {
                      id: "ae852e50b6bd11eb602305277b20c381",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-05-17T11:12:16.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-05-17T11:23:26.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "personalManage",
                      name: "个人数据配置-二开",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3f6b326065e811eba70f7fae370101e5",
                      type: "2",
                      icon: "su-icon-xiaoxileibie",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-query/personalManage",
                      target: "",
                      order: 12,
                      level: 3,
                      lft: 253,
                      rgt: 254,
                      children: [],
                    },
                    {
                      id: "67329180b6e711eb602305277b20c381",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-05-17T16:10:55.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-05-17T16:15:24.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "detailEdit",
                      name: "个人数据详情编辑-二开",
                      memo: "",
                      status: "1",
                      applicationId: "1",
                      parentId: "3f6b326065e811eba70f7fae370101e5",
                      type: "2",
                      icon: "su-icon-zujianmoban",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "/user-query/detailEdit",
                      target: "self",
                      order: 13,
                      level: 3,
                      lft: 257,
                      rgt: 258,
                      children: [],
                    },
                    {
                      id: "62f8e97065e811eba70f7fae370101e5",
                      companyId: "1",
                      deleted: false,
                      addAccount: "smartadmin",
                      addTime: "2021-02-03T14:23:53.000+0800",
                      editAccount: "smartadmin",
                      editTime: "2021-02-03T14:25:45.000+0800",
                      deleteAccount: null,
                      deleteTime: null,
                      code: "iframe-baidu",
                      name: "Baidu",
                      memo: "",
                      status: "1",
                      applicationId: "6ad20e002fb111ebfc7908c6df398873",
                      parentId: "3f6b326065e811eba70f7fae370101e5",
                      type: "2",
                      icon: "su-icon-sucaiku",
                      origin: "http://admin-platform.paas.newcapec.cn",
                      url: "https://www.baidu.com",
                      target: "iframe",
                      order: 0,
                      level: 3,
                      lft: 249,
                      rgt: 250,
                      children: [],
                    },
                  ],
                },
              ],
            },
            {
              id: "503e8270232811eb39a39bf283d87714",
              companyId: "1",
              deleted: false,
              addAccount: "smartadmin",
              addTime: "2020-11-10T15:42:42.000+0800",
              editAccount: "smartadmin",
              editTime: "2020-11-10T15:46:27.000+0800",
              deleteAccount: null,
              deleteTime: null,
              code: "ceshicaidan",
              name: "测试菜单",
              memo: "测试专用 切勿用在实际业务上",
              status: "1",
              applicationId: "1a1b1aa0232811eb39a39bf283d87714",
              parentId: "0",
              type: "2",
              icon: "su-icon-chongxintijiao",
              origin: "",
              url: "",
              target: null,
              order: 0,
              level: 1,
              lft: 1695,
              rgt: 1696,
              children: [],
            },
          ],
        },
      },
      testList: [],
      MenuList:[]
    };
  },
  created() {
    this.baseUserUrl = process.env.VUE_APP_REQUEST_ADMIN_BASE_URL;
    this.uploadUrl = `${process.env.VUE_APP_REQUEST_BASE_URL}v1/service/upload`;

    // this.menuList.tree.label = this.menuList.tree.name;
    // this.menuList.tree.value = this.menuList.tree.id;
    // this.menuList.tree.children.forEach(item => {
    //   item.label = item.name;
    //   item.value = item.id;
    //   item.children.forEach(item1 => {
    //     item1.label = item1.name;
    //     item1.value = item1.id;
    //     item1.children.forEach(item2 => {
    //       item2.label = item2.name;
    //       item2.value = item2.id;
    //       item2.children.forEach(item3 => {
    //         item3.label = item3.name;
    //         item3.value = item3.id;
    //       })
    //     })
    //   })
    // });
    // this.testList.push(this.menuList.tree)
  },
  mounted() {
    this.handMenuList();
    // this.handleColumnTemplateList();
    // this.handleColumnList();
    this.handleGetOrganizationTree();
    this.handleGetGroupTree();
    this.handleGetRoleTree();
    // this.handleWorkConList();
    if (this.$route.query.colId) {
      this.title = "修改菜单";
      this.columnId = this.$route.query.colId;
      this.handleMenuById();
    }
  },
  methods: {
    // 获取栏目模板列表
    handleColumnTemplateList() {
      let data = {
        templateType: "1",
      };
      getColumnTemplateList(data).then((res) => {
        this.columnTemplateList = res.data;
      });
    },
    // 获取栏目列表
    handleColumnList() {
      let data = {
        menuName: "",
      };
      getColumnList(data).then((res) => {
        this.columnList = res.data;
      });
    },
    // 获取菜单列表
    handMenuList() {
      let data = {};
      getMenuList(data).then((res) => {
        this.MenuList = res.data.list;
      });
    },
    // 获取全部部门
    handleGetOrganizationTree() {
      getOrganizationTree().then((res) => {
        if (res.code === 0) {
          this.OrganizationTree = res.data.items;
          this.cmsColumn.deptList = [];
          this.OrganizationTree.forEach((item) => {
            if (this.deptList.includes(item.id)) {
              this.cmsColumn.deptList.push(item);
            }
          });
        }
      });
    },
    // 获取全部用户组
    handleGetGroupTree() {
      getGroupTree().then((res) => {
        if (res.code === 0) {
          this.GroupTree = res.data.items;
        }
      });
    },
    // 获取全部角色
    handleGetRoleTree() {
      getRoleTree().then((res) => {
        if (res.code === 0) {
          this.RoleTree = res.data.roles;
        }
      });
    },
    // 部门选择
    chooseOrg(data) {
      this.DrawerTreeVisible = false;
      this.cmsColumn.deptList = data;
    },
    // 图标上传前文件校验
    beforeUpload(file) {
      // 格式
      const isSupportedFormats =
        file.type === "image/svg+xml" || file.type === "image/png";
      // 大小
      const isSupportedSize = file.size < 1024 * 200;

      if (!isSupportedFormats) {
        this.$message.error("只支持 svg / png 格式!");
      } else if (!isSupportedSize) {
        this.$message.error("图片大小不能超过 200kb!");
      }

      return isSupportedFormats && isSupportedSize;
    },
    // 图标上传成
    /**
     * 图片上传
     * @param file
     */
    onRequest({ file }) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "cms");
      this.$request({
        method: "POST",
        headerType: "portal",
        url: this.uploadUrl,
        data: formData,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.$set(this.cmsColumn, "menuIcon", data);
        }
      });
    },

    handleChange(value) {
      console.log(value);
      console.log(value[value.length - 1])
      this.cmsColumn.pid = value[value.length - 1];
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let cmsColumn = JSON.parse(JSON.stringify(this.cmsColumn));
          console.log("cmsColumn", cmsColumn);
          cmsColumn.deptList.forEach((item) => {
            this.deptList.push(item.id);
          });
          // delete cmsColumn.deptList;
          // delete cmsColumn.groupList;
          // delete cmsColumn.roleList;
          // if (cmsColumn.menuIcon) {
          //   cmsColumn.menuIcon = cmsColumn.menuIcon.replace(
          //     /^https?:\/\/[^/]+/,
          //     ""
          //   );
          // }
          if (this.columnId) {
            let id = this.columnId;
            cmsColumn.id = id;
          }
          let data = cmsColumn;
          saveOrUpdateMenu(data).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$router.push({ name: "DecisionManagement" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 根据id查询栏目内容 进行编辑
    handleMenuById() {
      let data = {
        id: this.columnId,
      };
      getMenuById(data).then((res) => {
        for (let attr in this.cmsColumn) {
          if (res.data[attr] === null || res.data[attr] === undefined) {
            this.cmsColumn[attr] = "";
          } else {
            this.cmsColumn[attr] = res.data[attr];
          }
        }
        // debugger
        // console.log("cmsColumn", this.cmsColumn);
       
        this.cmsColumn.id = this.columnId;
        this.deptList = res.data.depts;
        this.groupList = res.data.groupList;
        this.roleList = res.data.roleList;
        this.cmsColumn.deptList = res.data.depts;
        // console.log(this.cmsColumn.deptList)
        this.cmsColumn.roleList = res.data.roleList;
        this.cmsColumn.groupList = res.data.groupList;
        // this.handleGetOrganizationTree();
        console.log("cmsColumn", this.cmsColumn);
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },


  },
};
</script>

<style lang="scss">
.portalCms-addColumn {
  // padding: 16px 20px 0;
  margin-left: 50px;
  .decision-management-header {
    background: #f4f8fc;
    box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
    span {
      font-size: 12px;
      line-height: 32px;
      padding: 0 2px;
    }
    &-wrap {
      span {
        padding-left: 7px;
        border-left: 3px solid #3394e1;
        color: rgba(2, 21, 37, 0.45);
      }
    }
  }
  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 35px;
    padding: 16px 20px;
  }
  &-form {
    .el-select,
    .el-input,
    .el-textarea {
      width: 450px;
    }
  }
  &-userOrgSelect {
    display: none !important;
  }

  // element 添加图标css
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  // .el-drawer__body{
  //   height: 80vh;
  // }
  .DrawerTree {
    height: 80vh;
  }
  // .change-post-col{
  //   height: 80vh;
  // }
}
</style>